import * as actions from './redux/actions';
import * as commonActions from '../common/redux/actions';
import * as homeActions from '../home/redux/actions';
import * as paymentActions from '../pb-payment-details/redux/actions';
import * as serviceActions from '../pb-service-list/redux/actions';

import {
  KuposCheckbox,
  KuposDatePicker,
  KuposErrorSuccessModal,
  KuposInput,
  KuposModalWithButtons,
  KuposSelectBox,
  KuposSteps,
  PaymentOptions,
} from '../common';
import React, { Component, PureComponent } from 'react';

import ApiUrls from '../../services/apiUrls';
import { AppData } from '../../services';
import BookingSuccess from '../pb-payment-details/BookingSuccess';
import CommonService from '../../services/commonService';
import DateService from '../../services/dateService';
import KuposHelmet from '../common/KuposHelmet';
import PaymentRightSideBar from './PaymentRightSideBar';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../themes/functions/getIcons/getIcons';
import { withTranslation } from 'react-i18next';

class BookingInput extends PureComponent {
  // const {selectedSeatsToBook,countries,idCardTypes,name, countryName, cardNumber, nameError,cardNumberError onNameChange, onCountryChange, onIdCardChange, onIdCardNumberChange,onInputBlur} = this.props;
  constructor(props) {
    super(props);
    this.state = {};
  }

  PropTypes = {
    t: PropTypes.func,
  };

  nameChanged = (text, seat) => {
    this.props.onNameChange(text, seat);
  };

  last_nameChanged = (text, seat) => {
    this.props.onLastNameChange(text, seat);
  };
  inputBlur = (text, seat, inp) => {
    this.props.onInputBlur(text, seat, inp);
  };
  countryChanged = (val, seat) => {
    this.props.onCountryChange(val, seat);
  };
  idCardChanged = (val, seat) => {
    this.props.onIdCardChange(val, seat);
  };
  idCardNumberChanged = (text, seat) => {
    this.props.onIdCardNumberChange(text, seat);
  };

  //2nd row inputs
  onDOBChange = (val, seat) => {
    this.props.onUserDOBChange(val, seat);
  };

  originCountryChanged = (val, seat) => {
    this.props.onOriginCountryChange(val, seat);
  };

  originAddressChange = (val, seat) => {
    this.props.onOriginAddressChange(val, seat);
  };

  genderChange = (val, seat) => {
    this.props.onGenderChange(val, seat);
  };

  seatInputs = (seat, i) => {
    const { t } = this.props;
    let passengerDetails = CommonService.copyObject(this.props.passengerDetails);
    let passenger =
      passengerDetails && passengerDetails.length
        ? passengerDetails.find(it => seat.number == it.seatNumber)
        : null;

    let idCardType = passenger && passenger.idCardType;

    if (passenger && typeof passenger.idCardType === 'number') {
      idCardType = this.props.idCardTypes[passenger.idCardType === 7 ? 0 : 1];
    }

    const genderVal = [
      { value: 'male', label: 'HOME.MALE' },
      { value: 'female', label: 'HOME.FEMALE' },
    ];

    let internationalFlight = false;

    let originOnward = this.props.home.pbSourceCity.label;
    let destOnward = this.props.home.pbDestinationCity.label;

    if (
      // (originOnward && originOnward.indexOf('Santiago') > -1 && destOnward && destOnward.indexOf('argentina') < 0) ||
      (originOnward &&
        originOnward.indexOf('Argentina') > -1 &&
        destOnward &&
        destOnward.indexOf('Argentina') < 0) ||
      (originOnward &&
        originOnward.indexOf('Argentina') < 0 &&
        destOnward &&
        destOnward.indexOf('Argentina') > -1)
    ) {
      internationalFlight = true;
    }

    const dateObj = new Date();
    let maxDate = `${DateService.preZero(dateObj.getDate() - 1)}-${DateService.preZero(
      dateObj.getMonth() + 1,
    )}-${dateObj.getFullYear() - 0}`;

    return (
      <div className="local-international-inputs">
        <style>
          .pb-payment-details-default-page .local-international-inputs .local-inputs-headings {'{'}
          grid-template-columns: 3fr 3fr 3fr 5fr 5fr;
          {'}'}
          .pb-payment-details-default-page .local-international-inputs .local-inputs-details {'{'}
          grid-template-columns: 3fr 3fr 3fr 5fr 5fr;
          {'}'}
        </style>

        <div className="local-inputs-headings passenger-input-heading bold-text font10">
          <span className="nationality-input">{this.props.t('PASSENGER_DETAILS.NATIONALITY')}</span>
          <span className="doc-input">{this.props.t('PASSENGER_DETAILS.DOCUMENT')}</span>
          <span className="rut-input">{this.props.t('PASSENGER_DETAILS.DOC_NUM_DEGREE')}</span>
          <span className="name-input">{this.props.t('PASSENGER_DETAILS.NAME')}</span>
          <span className="last_name-input">{this.props.t('PASSENGER_DETAILS.SURNAME')}</span>
        </div>

        <div key={i} className="local-inputs-details passenger-input font10">
          {/* <div className="seat-number-input">
            <div
              className="kupos-border seat-value primary-text bold-text"
              style={{ cursor: 'default' }}
            >
              {seat.number}
            </div>
          </div> */}
          <div className="nationality-input">
            <KuposSelectBox
              options={this.props.countries}
              selectedOption={passenger ? passenger.nationality : {}}
              onChange={val => this.countryChanged(val, seat)}
              height={40}
              showAll={true}
              readonly={true}
              disabled={
                this.props.disabled
                  ? i + 1 <= this.props.noOfOnwardPassengers
                    ? true
                    : false
                  : false
              }
              t={t}
              marginTop={0.1}
              key={passenger && passenger.nationality && passenger.nationality.value}
              optionBgColor="#fec72d"
              optionTextColor="#000"
            />
          </div>
          <div className="doc-input">
            <KuposSelectBox
              options={this.props.idCardTypes}
              selectedOption={passenger ? idCardType : {}}
              onChange={val => this.idCardChanged(val, seat)}
              height={40}
              showAll={true}
              readonly={true}
              disabled={
                this.props.disabled
                  ? i + 1 <= this.props.noOfOnwardPassengers
                    ? true
                    : false
                  : false
              }
              t={t}
              marginTop={0.1}
              key={passenger && passenger.idCardType && passenger.idCardType.value}
              optionBgColor="#fec72d"
              optionTextColor="#000"
            />
          </div>
          <div className="rut-input">
            <KuposInput
              className="kupos-border"
              type="text"
              // placeholder= {t('PASSENGER_DETAILS.DOC_NUMBER')}
              value={passenger ? passenger.idCardNumber : ''}
              onChange={text => this.idCardNumberChanged(text, seat)}
              onBlur={text => this.inputBlur(text, seat, 'card_number')}
              disabled={
                this.props.disabled
                  ? i + 1 <= this.props.noOfOnwardPassengers
                    ? true
                    : false
                  : false
              }
              error={
                this.props.cardNumberError && this.props.cardNumberError[seat.number] ? true : false
              }
              errorMessage={
                this.props.cardNumberError && this.props.cardNumberError[seat.number]
                  ? t(this.props.cardNumberError[seat.number].message)
                  : ''
              }
            />
          </div>
          <div className="name-input">
            <KuposInput
              className="kupos-border"
              type="text"
              // placeholder={t('PASSENGER_DETAILS.NAME')}
              value={passenger ? passenger.name : ''}
              onChange={text => this.nameChanged(text, seat)}
              onBlur={text => this.inputBlur(text, seat, 'name')}
              disabled={
                this.props.disabled
                  ? i + 1 <= this.props.noOfOnwardPassengers
                    ? true
                    : false
                  : false
              }
              error={this.props.nameError && this.props.nameError[seat.number] ? true : false}
              errorMessage={
                this.props.nameError && this.props.nameError[seat.number]
                  ? t(this.props.nameError[seat.number].message)
                  : ''
              }
            />
          </div>
          <div className="name-input">
            <KuposInput
              className="kupos-border"
              type="text"
              // placeholder={t('PASSENGER_DETAILS.SURNAME')}
              value={passenger ? passenger.last_name : ''}
              onChange={text => this.last_nameChanged(text, seat)}
              disabled={
                this.props.disabled
                  ? i + 1 <= this.props.noOfOnwardPassengers
                    ? true
                    : false
                  : false
              }
              onBlur={text => this.inputBlur(text, seat, 'last_name')}
              error={
                this.props.last_nameError && this.props.last_nameError[seat.number] ? true : false
              }
              errorMessage={
                this.props.last_nameError && this.props.last_nameError[seat.number]
                  ? t(this.props.last_nameError[seat.number].message)
                  : ''
              }
            />
          </div>
        </div>

        {internationalFlight ? (
          <div className="international-inputs">
            <div className="local-inputs-headings passenger-input-heading row-2 bold-text font10">
              <span className="dob-input">{this.props.t('PASSENGER_DETAILS.USER_DOB')}</span>
              <span className="doc-input residency-input">
                {this.props.t('PASSENGER_DETAILS.USER_RESIDENCE')}
              </span>
              <span className="home-country-input">
                {this.props.t('PASSENGER_DETAILS.USER_DOMICILE')}
              </span>
              <span className="last_name-input gender-input">
                {this.props.t('PASSENGER_DETAILS.USER_GENDER')}
              </span>
            </div>

            <div key={i} className="passenger-input local-inputs-details font10">
              <div className="dob-input">
                <KuposDatePicker
                  // minDate={'23-11-2022'}
                  selectedDate={passenger && passenger.dob ? passenger.dob : null}
                  onDateChange={date => {
                    this.onDOBChange(date, seat);
                  }}
                  canChangeYear={true}
                  disabled={
                    this.props.disabled
                      ? i + 1 <= this.props.noOfOnwardPassengers
                        ? true
                        : false
                      : false
                  }
                  error={this.props.dobError && this.props.dobError[seat.number] ? true : false}
                  errorMessage={
                    this.props.dobError && this.props.dobError[seat.number]
                      ? t(this.props.dobError[seat.number].message)
                      : ''
                  }
                  t={this.props.t}
                  // maxDate={'07-12-2022'}
                  maxDate={maxDate}
                />
              </div>
              <div className="doc-input">
                <KuposSelectBox
                  options={this.props.countries}
                  selectedOption={passenger ? passenger.countryOfOrigin : {}}
                  onChange={val => this.originCountryChanged(val, seat)}
                  height={44}
                  showAll={true}
                  readonly={true}
                  placeholder={this.props.t('PROFILE.COUNTRY')}
                  disabled={
                    this.props.disabled
                      ? i + 1 <= this.props.noOfOnwardPassengers
                        ? true
                        : false
                      : false
                  }
                  t={t}
                  marginTop={0.1}
                  key={passenger && passenger.countryOfOrigin && passenger.countryOfOrigin.value}
                  error={
                    this.props.originCountryError && this.props.originCountryError[seat.number]
                      ? true
                      : false
                  }
                  errorMessage={
                    this.props.originCountryError && this.props.originCountryError[seat.number]
                      ? t(this.props.originCountryError[seat.number].message)
                      : ''
                  }
                />
              </div>

              <div className="home-country-input">
                <KuposInput
                  className="kupos-border"
                  type="text"
                  t={this.props.t}
                  placeholder={'PASSENGER_DETAILS.USER_DOMICILE'}
                  value={passenger ? passenger.addressOfOrigin : ''}
                  onChange={text => this.originAddressChange(text, seat)}
                  onBlur={text => this.inputBlur(text, seat, 'originAddress')}
                  disabled={
                    this.props.disabled
                      ? i + 1 <= this.props.noOfOnwardPassengers
                        ? true
                        : false
                      : false
                  }
                  error={
                    this.props.originAddressError && this.props.originAddressError[seat.number]
                      ? true
                      : false
                  }
                  errorMessage={
                    this.props.originAddressError && this.props.originAddressError[seat.number]
                      ? t(this.props.originAddressError[seat.number].message)
                      : ''
                  }
                />
              </div>
              <div className="last_name-input">
                <KuposSelectBox
                  selectedOption={passenger ? passenger.gender : {}}
                  options={genderVal}
                  onChange={val => this.genderChange(val, seat)}
                  height={40}
                  showAll={true}
                  readonly={true}
                  disabled={
                    this.props.disabled
                      ? i + 1 <= this.props.noOfOnwardPassengers
                        ? true
                        : false
                      : false
                  }
                  placeholder={this.props.t('PROFILE.GENDER')}
                  // error={genderError ? true : false}
                  // errorMessage={genderError ? genderError.message : ''}
                  t={t}
                  marginTop={0.1}
                  key={passenger && passenger.gender && passenger.gender.value}
                  error={
                    this.props.genderError && this.props.genderError[seat.number] ? true : false
                  }
                  errorMessage={
                    this.props.genderError && this.props.genderError[seat.number]
                      ? t(this.props.genderError[seat.number].message)
                      : ''
                  }
                />
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  };

  render() {
    return (
      <div>
        {this.props.selectedSeatsToBook.map((seat, i) =>
          !seat.is_pet_seat ? this.seatInputs(seat, i) : null,
        )}
      </div>
    );
  }
}

class DefaultPage extends Component {
  static propTypes = {
    pbServiceList: PropTypes.object,
    home: PropTypes.object,
    common: PropTypes.object,
    pbPaymentDetails: PropTypes.object,
    actions: PropTypes.object,
  };
  countrieCodes = [];
  paymentGatewayList;
  countries = [];
  idCardTypes = [];
  idCardTypesReturn = [];

  constructor(props) {
    super(props);

    this.operator = CommonService.getLocal('op');

    this.operatorUrl = this.operator
      ? `?operator_id=${this.operator.operator_id}&referral_code=${this.operator.referral_code}`
      : '';

    this.iframe_operator_id = this.operator ? this.operator.operator_id : '';
    this.referral_code = this.operator ? this.operator.referral_code : '';
    // console.log('url', this.operatorUrl)
    try {
      const { status, pnrNumber } = this.props.match.params;
      let fromPaymentGateway = localStorage.getItem('paymentGatewayOpened');
      if (fromPaymentGateway && !status) {
        this.props.history.replace(``, null);
        let homeData = JSON.parse(localStorage.getItem('home'));
        if (homeData && homeData.pbSourceCity && homeData.pbDestinationCity) {
          let source = homeData.pbSourceCity.label
            .toLowerCase()
            .replace(/-/g, '_')
            .replace(/ /g, '-')
            .replace(/_/g, '--');
          let dest = homeData.pbDestinationCity.label
            .toLowerCase()
            .replace(/-/g, '_')
            .replace(/ /g, '-')
            .replace(/_/g, '--');
          let path = `/${
            CommonService.isTrain() ? 'es/pasajes-tren' : 'es/pasajes-bus'
          }/${source}/${dest}/${homeData.onwardPBDate}`;
          if (homeData.returnPBDate) {
            path = `/${
              CommonService.isTrain() ? 'es/pasajes-tren' : 'es/pasajes-bus'
            }/${source}/${dest}/${homeData.onwardPBDate}/${homeData.returnPBDate}/1`;
          }
          this.props.history.push(path);
        } else {
          this.props.history.push(`/booking/failure${this.operatorUrl}`);
        }
      }
      this.initialize();

      // this.props.actions.setBookingJSONDetails(null);
    } catch (e) {
      console.log(e);
      this.props.history.push(`/`);
    }

    this.state = {
      oneClickCardTypes: null,
      cardChecked: false,
      internationalService: false,
      motData: null,
      tariffData: {
        fare: 0,
      },
      isLoading: false,
      isRoundTrip: false,
    };

    //Get one click cards

    let queryParams = '';
    if (CommonService.shouldPassOperatorId(this.operator)) {
      queryParams = 'operator_id=' + CommonService.getOperatorId(this.operator);
    }

    this.props.actions
      .apiCall({
        url: AppData.BASE_URL + 'api/my_cards_list?' + queryParams,
        type: 'home',
      })
      .then(
        res => this.onOneClickCardsFetch(res),
        err => this.onOneClickCardsFetch(err),
      );
    //  this.state.idCardTypes = this.idCardTypes;
    //  this.state.idCardTypesReturn = this.idCardTypesReturn;

    setTimeout(() => {
      this.operator && this.checkSession();
    }, 1000);
  }

  checkSession = () => {
    let queryParams = '';
    if (CommonService.shouldPassOperatorId(this.operator)) {
      queryParams = 'operator_id=' + CommonService.getOperatorId(this.operator);
    }
    this.props.actions
      .apiCall({
        url: AppData.BASE_URL + 'api/customer/profile?' + queryParams,
        type: 'home',
        noRedirect: true,
      })
      .then(
        res => {
          if (res && res.error) {
            return;
          } else if (res && res.auth_token) {
            CommonService.storeLoginDetails(res, this.props.actions.setLoginData);
          }
        },
        err => {},
      );
  };

  onOneClickCardsFetch = result => {
    if (result && result.data && result.data.card_details) {
      this.setState({ myCards: result.data.card_details });
    }

    this.setState({ showPaymentsOptions: true });
  };

  initialize = () => {
    const { status, pnrNumber } = this.props.match.params;
    if (status) {
      localStorage.removeItem('paymentGatewayOpened');
      localStorage.removeItem('pbServiceList');

      this.props.actions.setServiceOnward({
        coachLayoutJson: null,
        originStageDetails: null,
        destinationStageDetails: null,
        boardingStage: null,
        droppingStage: null,
        route: null,
      });
      this.props.actions.setServiceReturn({
        coachLayoutJson: null,
        originStageDetails: null,
        destinationStageDetails: null,
        boardingStage: null,
        droppingStage: null,
        route: null,
      });
      this.props.actions.selectSeatOnward({
        totalBookingAmount: 0,
        netBookingAmount: 0,
        discountAmount: 0,
        selectedSeatsToBook: null,
        selectedSeatsNumbers: null,
        selectedSeatTypes: null,
      });
      this.props.actions.selectSeatReturn({
        totalBookingAmount: 0,
        netBookingAmount: 0,
        discountAmount: 0,
        selectedSeatsToBook: null,
        selectedSeatsNumbers: null,
        selectedSeatTypes: null,
      });
      if (this.countdownInterVal) clearInterval(this.countdownInterVal);
    }
    let metaData;
    if (!this.props.home.metaData || !this.props.home.onwardPBDate) {
      this.home = CommonService.getLocal('home');
      if (this.home) {
        metaData = this.home.metaData;
        this.pbServiceList = CommonService.getLocal('pbServiceList');
        if (this.pbServiceList) this.setHomeAndServiceState(this.home, this.pbServiceList);
        else {
          if (
            this.props.pbServiceList.bookingDetailsOnward.selectedSeatsNumbers ||
            this.pbServiceList
          ) {
            CommonService.setLocal('pbServiceList', this.props.pbServiceList);
          } else if (!status) {
            this.props.history.push(`/`);
          }
        }
      } else if (!status) {
        this.props.history.push(`/`);
      }
    } else {
      this.home = this.props.home;
      metaData = this.props.home.metaData;
      this.pbServiceList = CommonService.getLocal('pbServiceList');
      if (!this.pbServiceList) {
        CommonService.setLocal('pbServiceList', this.props.pbServiceList);
        this.pbServiceList = this.props.pbServiceList;
        if (
          !this.props.pbServiceList.bookingDetailsOnward.selectedSeatsNumbers &&
          !this.pbServiceList &&
          !status
        ) {
          this.props.history.push(`/`);
        }
      }
    }
    if (metaData) {
      for (let c of metaData.country_codes) {
        this.countrieCodes.push({
          value: c,
          label: '+' + c,
        });
      }
      for (let c in metaData.nationality_list) {
        this.countries.push({
          value: metaData.nationality_list[c],
          label: c.substring(0, 3).toUpperCase(),
        });
      }
      for (let c in metaData.id_card_types) {
        if (this.idCardTypes.length <= 1) {
          this.idCardTypes.push({
            value: metaData.id_card_types[c],
            label: c,
          });
        }
      }
      this.paymentGatewayList = CommonService.copyObject(metaData.payment_gate_way_list_v1);
    }
    this.status = status;
    this.pnrNumber = pnrNumber;
    this.timer = sessionStorage.getItem('paymentCounter');
    this.state = {
      mobileError: null,
      emailError: null,
      confirmEmailError: null,
      selectedPaymentGateway: null,
      payment_mode: null,
      showBookingConfirmModal: false,
      wallet: false,
      walletMoney: 0,
      confirmTabSelected: 1,

      nameError: {},
      last_nameError: {},
      cardNumberError: {},
      nameReturnError: {},
      last_nameReturnError: {},
      cardNumberReturnError: {},
      idCardTypes: [],
      idCardTypesReturn: [],
      status: status,
      countdown: '09:00',
      dobError: {},
      dobReturnError: {},
      corporateDiscountState: null,
    };
    let contactDetails = {
      countryCode: this.countrieCodes && this.countrieCodes[0] ? this.countrieCodes[0].name : '',
      mobile: this.props.common.loginData ? this.props.common.loginData.phone : null,
      email: this.props.common.loginData ? this.props.common.loginData.email : null,
      confirmEmail: this.props.common.loginData ? this.props.common.loginData.email : null,
    };
    this.props.actions.setContactDetails(contactDetails);
    let passengerDetailsOnward = [];
    let i = 0;
    let pbServiceList = this.pbServiceList;
    if (
      pbServiceList &&
      pbServiceList.bookingDetailsOnward &&
      pbServiceList.bookingDetailsOnward.selectedSeatsToBook
    ) {
      for (let s of pbServiceList.bookingDetailsOnward.selectedSeatsToBook) {
        passengerDetailsOnward.push({
          floorNo: s.floor_no || s.floor_no === 0 ? s.floor_no + 1 : null,
          seatNumber: s.number,
          name: i == 0 && this.props.common.loginData ? this.props.common.loginData.name : null,
          last_name:
            i == 0 && this.props.common.loginData ? this.props.common.loginData.last_name : null,
          nationality: this.countries[0],
          idCardType:
            i == 0 && this.props.common.loginData && Object.keys(this.props.common.loginData).length
              ? this.idCardTypes.find(it => it.value == this.props.common.loginData.identity_type)
              : this.idCardTypes.find(it => it.value == 7),
          idCardNumber:
            i == 0 && this.props.common.loginData && Object.keys(this.props.common.loginData).length
              ? this.props.common.loginData.identity_val
              : null,
          fare: s.fare,
          isPeatSeat: s && s.is_pet_seat ? true : false,
        });
        //  let cardTypes = [];
        //  for(let c in metaData.id_card_types){
        //      cardTypes.push({
        //          value:metaData.id_card_types[c],
        //          id:metaData.id_card_types[c],
        //          label:c,
        //          name:c,
        //          selected:(this.props.common.loginData && i == 0) ? (metaData.id_card_types[c] == this.props.common.loginData.identity_type) : (metaData.id_card_types[c] == 7)
        //      })
        //  }
        //  this.idCardTypes.push(cardTypes);
        i++;
      }
    }
    i = 0;
    this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);
    if (
      pbServiceList &&
      pbServiceList.bookingDetailsOnward &&
      pbServiceList.bookingDetailsOnward.selectedSeatsToBook
    ) {
      setTimeout(() => {
        for (let seat of pbServiceList.bookingDetailsOnward.selectedSeatsToBook) {
          if (seat.is_pet_seat) {
            let passenger = passengerDetailsOnward.find(it => seat.number == it.seatNumber);
            let passenger2 = passengerDetailsOnward.find(
              it => seat.associated_seat == it.seatNumber,
            );
            if (passenger2) {
              passenger2.name = passenger.name;
              passenger2.last_name = passenger.last_name;
              passenger2.nationality = passenger.nationality;
              passenger2.idCardType = passenger.idCardType;
              passenger2.idCardNumber = passenger.idCardNumber;
              this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);
            }
          }
        }
      }, 1500);
    }

    if (!this.props.common.loginData) {
      this.fillPassengerAutoData();
    }
    if (this.home && this.home.returnPBDate) {
      let passengerDetailsReturn = [];
      if (pbServiceList && pbServiceList.bookingDetailsReturn.selectedSeatsToBook) {
        for (let s of pbServiceList.bookingDetailsReturn.selectedSeatsToBook) {
          passengerDetailsReturn.push({
            floorNo: s.floor_no || s.floor_no === 0 ? s.floor_no + 1 : null,
            seatNumber: s.number,
            name: null,
            nationality: this.countries[0],
            idCardType: this.idCardTypes.find(it => it.value == 7),
            idCardNumber: null,
            fare: s.fare,
            isPeatSeat: s && s.is_pet_seat ? true : false,
          });
          //  let cardTypes = [];
          //  for(let c in metaData.id_card_types){
          //      cardTypes.push({
          //          value:metaData.id_card_types[c],
          //          id:metaData.id_card_types[c],
          //          label:c,
          //          name:c,
          //          selected:(metaData.id_card_types[c] == 7)
          //      })
          //  }
          //  this.idCardTypesReturn.push(cardTypes);
          i++;
        }
      }
      this.props.actions.setPassengerDetailsReturn(passengerDetailsReturn);
      setTimeout(() => {
        for (let seat of pbServiceList.bookingDetailsReturn.selectedSeatsToBook) {
          if (seat.is_pet_seat) {
            let passenger = passengerDetailsOnward.find(it => seat.number == it.seatNumber);
            let passenger2 = passengerDetailsOnward.find(
              it => seat.associated_seat == it.seatNumber,
            );
            if (passenger2) {
              passenger2.name = passenger.name;
              passenger2.last_name = passenger.last_name;
              passenger2.nationality = passenger.nationality;
              passenger2.idCardType = passenger.idCardType;
              passenger2.idCardNumber = passenger.idCardNumber;
              this.props.actions.setPassengerDetailsReturn(passengerDetailsReturn);
            }
          }
        }
      }, 1500);
    }
    this.updatePassengerDetailsFromCache();
    if (this.props.common.loginData) {
      setTimeout(() => {
        if (this.isAllInputsValid()) {
          this.checkCorporateDiscount();
          this.callInstantDiscountAPI();
        }
      }, 1000);
    }
  };

  fillPassengerAutoData = () => {
    setTimeout(() => {
      try {
        let passengerDetailsOnward = CommonService.copyObject(
          this.props.pbPaymentDetails.passengerDetailsOnward,
        );
        passengerDetailsOnward[0].name = this.props.common.loginData
          ? this.props.common.loginData.name
          : null;
        passengerDetailsOnward[0].last_name = this.props.common.loginData
          ? this.props.common.loginData.last_name
          : null;
        // eslint-disable-next-line no-unused-expressions
        (passengerDetailsOnward[0].idCardType =
          this.props.common.loginData && Object.keys(this.props.common.loginData).length
            ? this.idCardTypes.find(it => it.value == this.props.common.loginData.identity_type)
            : this.idCardTypes.find(it => it.value == 7)),
          (passengerDetailsOnward[0].idCardNumber =
            this.props.common.loginData && Object.keys(this.props.common.loginData).length
              ? this.props.common.loginData.identity_val
              : null);
        this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);

        let contactDetails = {
          countryCode:
            this.countrieCodes && this.countrieCodes[0] ? this.countrieCodes[0].name : '',
          mobile: this.props.common.loginData ? this.props.common.loginData.phone : null,
          email: this.props.common.loginData ? this.props.common.loginData.email : null,
          confirmEmail: this.props.common.loginData ? this.props.common.loginData.email : null,
        };
        this.props.actions.setContactDetails(contactDetails);
        CommonService.loginCallbackFunction = null;
      } catch (e) {
        console.log(e);
      }

      if (this.props.common.loginData) {
        setTimeout(() => {
          if (this.isAllInputsValid()) {
            this.checkCorporateDiscount();
            this.callInstantDiscountAPI();
          }
        }, 1000);
      }
    }, 300);
  };

  setHomeAndServiceState = (home, service) => {
    // this.props.actions.setOnwardPbDate(home.metaData);
    this.props.actions.setHomeState(home);
    this.props.actions.setServiceState(service);
  };

  componentDidMount() {
    setTimeout(() => {
      this.initialize();
      this.setState({
        oneClickCardTypes: this.props.home.metaData ? this.props.home.metaData.card_type : null,
      });
      this.setState({
        isOneClickEnabled: this.props.home.metaData
          ? this.props.home.metaData.is_oneclick_card_enable
          : null,
      });
    }, 500);

    if (!this.props.common.loginData) {
      let contactDetails = {
        countryCode: '',
        mobile: '',
        email: '',
        confirmEmail: '',
      };

      try {
        let passengerDetailsOnward = CommonService.copyObject(
          this.props.pbPaymentDetails.passengerDetailsOnward,
        );
        for (let passenger of passengerDetailsOnward) {
          passenger.name = '';
          passenger.last_name = '';
          passenger.nationality = this.countries[0];
          passenger.idCardType = this.idCardTypes.find(it => it.value == 7);
          passenger.idCardNumber = '';
        }
        if (passengerDetailsOnward[0]) {
          passengerDetailsOnward[0].name = '';
          passengerDetailsOnward[0].last_name = '';
          passengerDetailsOnward[0].identity_val = '';
        }

        this.props.actions.setContactDetails(passengerDetailsOnward);
        this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);
        let passengerDetailsReturn = CommonService.copyObject(
          this.props.pbPaymentDetails.passengerDetailsReturn,
        );
        for (let passenger of passengerDetailsReturn) {
          passenger.name = '';
          passenger.last_name = '';
          passenger.nationality = this.countries[0];
          passenger.idCardType = this.idCardTypes.find(it => it.value == 7);
          passenger.idCardNumber = '';
        }
        this.props.actions.setPassengerDetailsReturn(passengerDetailsReturn);
      } catch (e) {
        console.log('eeeeeeeee', e);
      }
      this.props.actions.setContactDetails(contactDetails);
    }

    try {
      this.html = document.querySelector('html');
      this.html.style.scrollBehavior = 'initial';
      setTimeout(() => {
        window.scrollTo(0, 0);
        setTimeout(() => {
          this.html.style.scrollBehavior = 'smooth';
        }, 200);
      }, 200);
      const { status, pnrNumber } = this.props.match.params;
      this.status = status;
      this.pnrNumber = pnrNumber;
      if (this.status == 'success' && this.pnrNumber) {
        this.props.actions.loadTicketDetails({
          url: ApiUrls.ticketDetails(this.pnrNumber),
        });
      }
      if (!this.home || !this.home.returnPBDate) this.setupStepMenu(this.status ? 3 : 2, 1);
      else this.setupStepMenu(this.status ? 4 : 3, 2);

      if (!this.status) this.startCountDown();
      const myInput = document.querySelector('.confirm-email');
      if (myInput) {
        myInput.onpaste = function(e) {
          e.preventDefault();
        };
      }
    } catch (e) {
      console.log(e);
    }

    let originOnward =
      this.props.home && this.props.home.pbSourceCity && this.props.home.pbSourceCity.label;
    let destOnward =
      this.props.home &&
      this.props.home.pbDestinationCity &&
      this.props.home.pbDestinationCity.label;

    if (
      // (originOnward && originOnward.indexOf('Santiago') > -1 && destOnward && destOnward.indexOf('argentina') < 0) ||
      (originOnward &&
        originOnward.indexOf('Argentina') > -1 &&
        destOnward &&
        destOnward.indexOf('Argentina') < 0) ||
      (originOnward &&
        originOnward.indexOf('Argentina') < 0 &&
        destOnward &&
        destOnward.indexOf('Argentina') > -1)
    ) {
      this.setState({ internationalService: true });
    }

    const tariffData = JSON.parse(sessionStorage.getItem('tariffData'));
    if (tariffData) {
      this.setState({ tariffData: tariffData });
    }

    const searchParams = new URLSearchParams(window.location.search);

    if (searchParams.get('round_trip')) {
      this.setState({ isRoundTrip: true });
    }
  }

  updatePassengerDetailsFromCache = () => {
    setTimeout(() => {
      try {
        if (CommonService.passengerDetailsOnward) {
          let passengerDetailsOnward = CommonService.copyObject(
            this.props.pbPaymentDetails.passengerDetailsOnward,
          );
          let i = 0;
          for (let passenger of passengerDetailsOnward) {
            let pInfo = CommonService.passengerDetailsOnward[i];
            if (pInfo) {
              passenger.name = pInfo.name || '';
              passenger.last_name = pInfo.last_name || '';
              passenger.nationality = pInfo.nationality || passenger.nationality;
              passenger.idCardType = pInfo.idCardType || passenger.idCardType;
              passenger.idCardNumber = pInfo.idCardNumber || passenger.idCardNumber;
            }
            i++;
          }
          this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);

          let pContact = CommonService.passengerContactDetails;
          if (pContact) {
            let contactDetails = {
              countryCode: pContact.countrieCode || '',
              mobile: pContact.mobile || '',
              email: pContact.email || '',
              confirmEmail: pContact.confirmEmail || '',
            };
            this.props.actions.setContactDetails(contactDetails);
          }

          if (CommonService.passengerDetailsReturn) {
            let passengerDetailsReturn = CommonService.copyObject(
              this.props.pbPaymentDetails.passengerDetailsReturn,
            );
            let i = 0;
            for (let passenger of passengerDetailsReturn) {
              let pInfo = CommonService.passengerDetailsReturn[i];
              if (pInfo) {
                passenger.name = pInfo.name || '';
                passenger.last_name = pInfo.last_name || '';
                passenger.nationality = pInfo.nationality || passenger.nationality;
                passenger.idCardType = pInfo.idCardType || passenger.idCardType;
                passenger.idCardNumber = pInfo.idCardNumber || passenger.idCardNumber;
              }
              i++;
            }
            this.props.actions.setPassengerDetailsReturn(passengerDetailsReturn);
          }
        }
      } catch (e) {}
    }, 600);
  };

  componentDidUpdate() {}

  startCountDown = () => {
    var timer = this.timer && !isNaN(this.timer) ? +this.timer : 60 * 9,
      minutes,
      seconds;
    this.countdownInterVal = setInterval(() => {
      minutes = parseInt(timer / 60, 10);
      seconds = parseInt(timer % 60, 10);

      minutes = minutes < 10 ? '0' + minutes : minutes;
      seconds = seconds < 10 ? '0' + seconds : seconds;

      this.setState({
        countdown: minutes + ':' + seconds,
      });

      sessionStorage.setItem('paymentCounter', timer);
      if (--timer < 0) {
        clearInterval(this.countdownInterVal);
        this.setState({ showTimeUpModal: true });
        // this.props.history.push('/');
      }
    }, 1000);
  };

  componentWillUnmount = () => {
    sessionStorage.removeItem('paymentCounter');
    if (this.countdownInterVal) clearInterval(this.countdownInterVal);
  };

  setupStepMenu = (step, type) => {
    let stepsMenu;
    if (type == 1) {
      stepsMenu = [
        { label: 'GOING', active: step == 1 },
        { label: 'PAYMENT', active: step == 2 },
        { label: 'CONFIRMATION', active: step == 3 },
      ];
    } else {
      stepsMenu = [
        { label: 'GOING', active: step == 1 },
        { label: 'RETURN', active: step == 2 },
        { label: 'PAYMENT', active: step == 3 },
        { label: 'CONFIRMATION', active: step == 4 },
      ];
    }
    this.setState({ stepsMenu: stepsMenu, status: this.status, pnrNumber: this.pnrNumber });
  };

  onInputChange = (text, inp) => {
    try {
      //  if(text){
      if (inp == 'mobile') {
        this.setState({
          mobileError: null,
        });
        let contactDetails = CommonService.copyObject(this.props.pbPaymentDetails.contactDetails);
        if (contactDetails) {
          text = CommonService.phoneNumberFormat(text, 9);
          contactDetails.mobile = text;
          this.props.actions.setContactDetails(contactDetails);
        }
      } else if (inp == 'email') {
        this.setState({
          emailError: null,
        });
        let contactDetails = CommonService.copyObject(this.props.pbPaymentDetails.contactDetails);
        if (contactDetails) {
          contactDetails.email = text.trim().toLowerCase();
          this.props.actions.setContactDetails(contactDetails);
        }
      } else if (inp == 'confirmEmail') {
        this.setState({
          confirmEmailError: null,
        });
        let contactDetails = CommonService.copyObject(this.props.pbPaymentDetails.contactDetails);
        if (contactDetails) {
          contactDetails.confirmEmail = text.trim().toLowerCase();
          this.props.actions.setContactDetails(contactDetails);
        }
      }
    } catch (e) {
      console.log(e);
    }
    //  }
  };

  onInputBlurContact = (text, inp) => {
    try {
      if (!text) {
        if (inp == 'mobile') {
          this.setState({
            mobileError: {
              message: 'VALIDATIONS.VALID_MOBILE',
            },
          });
        } else if (inp == 'email') {
          this.setState({
            emailError: {
              message: 'VALIDATIONS.VALID_EMAIL',
            },
          });
        } else if (inp == 'confirmEmail') {
          this.setState({
            confirmEmailError: {
              message: 'VALIDATIONS.VALID_CONFIRM_EMAIL',
            },
          });
        }
      } else {
        let contactDetails = CommonService.copyObject(this.props.pbPaymentDetails.contactDetails);

        if (inp == 'mobile') {
          if (isNaN(text)) {
            this.setState({
              mobileError: {
                message: 'VALIDATIONS.VALID_MOBILE',
              },
            });
          } else if (text.toString().length != 9) {
            this.setState({
              mobileError: {
                message: 'VALIDATIONS.VALID_MOBILE_LENGTH_9',
              },
            });
          }
        } else if (inp == 'email') {
          if (!CommonService.isEMailValid(text)) {
            this.setState({
              emailError: {
                message: 'VALIDATIONS.VALID_EMAIL',
              },
            });
          }
        } else if (inp == 'confirmEmail') {
          if (contactDetails.confirmEmail.toLowerCase() != contactDetails.email.toLowerCase()) {
            this.setState({
              confirmEmailError: {
                message: 'VALIDATIONS.VALID_EMAIL_MATCH',
              },
            });
          }
        }
      }

      if (this.isAllInputsValid()) {
        this.checkCorporateDiscount();
        this.callInstantDiscountAPI();
      }
    } catch (e) {
      console.log(e);
    }
  };

  // --------- booking seats input on change/blur code start -------------------
  onNameChange = (text, seat) => {
    try {
      let nameError = CommonService.copyObject(this.state.nameError);
      if (nameError) {
        nameError[seat.number] = null;
      }
      this.setState({
        nameError: nameError,
      });
      let passengerDetailsOnward = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsOnward,
      );
      let passenger = passengerDetailsOnward.find(it => seat.number == it.seatNumber);
      if (passenger) {
        passenger.name = text;
        this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);
      }
    } catch (e) {
      console.log(e);
    }
  };
  onNameChangeReturn = (text, seat) => {
    try {
      let nameReturnError = CommonService.copyObject(this.state.nameReturnError);
      if (nameReturnError) {
        nameReturnError[seat.number] = null;
      }
      this.setState({
        nameReturnError: nameReturnError,
      });
      let passengerDetailsReturn = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsReturn,
      );
      let passenger = passengerDetailsReturn.find(it => seat.number == it.seatNumber);
      if (passenger) {
        passenger.name = text;
        this.props.actions.setPassengerDetailsReturn(passengerDetailsReturn);
      }
    } catch (e) {
      console.log(e);
    }
  };
  onLastNameChange = (text, seat) => {
    try {
      let last_nameError = CommonService.copyObject(this.state.last_nameError);
      if (last_nameError) {
        last_nameError[seat.number] = null;
      }
      this.setState({
        last_nameError: last_nameError,
      });
      let passengerDetailsOnward = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsOnward,
      );
      let passenger = passengerDetailsOnward.find(it => seat.number == it.seatNumber);
      if (passenger) {
        passenger.last_name = text;
        this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);
      }
    } catch (e) {
      console.log(e);
    }
  };
  onLastNameChangeReturn = (text, seat) => {
    try {
      let last_nameReturnError = CommonService.copyObject(this.state.last_nameReturnError);
      if (last_nameReturnError) {
        last_nameReturnError[seat.number] = null;
      }
      this.setState({
        last_nameReturnError: last_nameReturnError,
      });
      let passengerDetailsReturn = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsReturn,
      );
      let passenger = passengerDetailsReturn.find(it => seat.number == it.seatNumber);
      if (passenger) {
        passenger.last_name = text;
        this.props.actions.setPassengerDetailsReturn(passengerDetailsReturn);
      }
    } catch (e) {
      console.log(e);
    }
  };
  onCountryChange = (val, seat) => {
    try {
      let passengerDetailsOnward = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsOnward,
      );
      let passenger = passengerDetailsOnward.find(it => seat.number == it.seatNumber);
      if (passenger) {
        passenger.nationality = val;
        this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);
      }
    } catch (e) {
      console.log(e);
    }
  };
  onCountryChangeReturn = (val, seat) => {
    try {
      // console.log(val, seat);
      let passengerDetailsReturn = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsReturn,
      );
      let passenger = passengerDetailsReturn.find(it => seat.number == it.seatNumber);
      if (passenger) {
        passenger.nationality = val;
        this.props.actions.setPassengerDetailsReturn(passengerDetailsReturn);
      }
    } catch (e) {
      console.log(e);
    }
  };
  onIdCardChange = (val, seat) => {
    try {
      let passengerDetailsOnward = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsOnward,
      );
      let passenger = passengerDetailsOnward.find(it => seat.number == it.seatNumber);
      if (passenger) {
        passenger.idCardType = val;
        passenger.idCardNumber = '';
        let cardNumberError = CommonService.copyObject(this.state.cardNumberError);
        if (cardNumberError) {
          cardNumberError[seat.number] = null;
        }
        this.setState({
          cardNumberError: cardNumberError,
        });
        this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);
      }
    } catch (e) {
      console.log(e);
    }
  };
  onIdCardChangeReturn = (val, seat) => {
    try {
      let passengerDetailsReturn = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsReturn,
      );
      let passenger = passengerDetailsReturn.find(it => seat.number == it.seatNumber);
      if (passenger) {
        passenger.idCardType = val;
        passenger.idCardNumber = '';
        let cardNumberReturnError = CommonService.copyObject(this.state.cardNumberReturnError);
        if (cardNumberReturnError) {
          cardNumberReturnError[seat.number] = null;
        }
        this.setState({
          cardNumberReturnError: cardNumberReturnError,
        });
        this.props.actions.setPassengerDetailsReturn(passengerDetailsReturn);
      }
    } catch (e) {
      console.log(e);
    }
  };
  onIdCardNumberChange = (text, seat) => {
    try {
      if (text.trim()) {
        let cardNumberError = CommonService.copyObject(this.state.cardNumberError);
        if (cardNumberError) {
          cardNumberError[seat.number] = null;
        }
        this.setState({
          cardNumberError: cardNumberError,
        });
      }

      let passengerDetailsOnward = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsOnward,
      );
      let passenger = passengerDetailsOnward.find(it => seat.number == it.seatNumber);
      if (passenger) {
        passenger.idCardNumber = text;
        this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);
      }
    } catch (e) {
      console.log(e);
    }
  };
  onIdCardNumberChangeReturn = (text, seat) => {
    try {
      if (text.trim()) {
        let cardNumberReturnError = CommonService.copyObject(this.state.cardNumberReturnError);
        if (cardNumberReturnError) {
          cardNumberReturnError[seat.number] = null;
        }
        this.setState({
          cardNumberReturnError: cardNumberReturnError,
        });
      }
      let passengerDetailsReturn = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsReturn,
      );
      let passenger = passengerDetailsReturn.find(it => seat.number == it.seatNumber);
      if (passenger) {
        passenger.idCardNumber = text;
        this.props.actions.setPassengerDetailsReturn(passengerDetailsReturn);
      }
    } catch (e) {
      console.log(e);
    }
  };

  //2nd row inputs onward starts
  onUserDOBChange = (text, seat) => {
    try {
      let dobError = CommonService.copyObject(this.state.dobError);
      if (dobError) {
        dobError[seat.number] = null;
      }
      this.setState({
        dobError: dobError,
      });
      let passengerDetailsOnward = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsOnward,
      );
      let passenger = passengerDetailsOnward.find(it => seat.number == it.seatNumber);
      if (passenger) {
        passenger.dob = text;
        this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);
      }
    } catch (e) {
      console.log(e);
    }
  };

  onOriginCountryChange = (val, seat) => {
    try {
      let originCountryError = CommonService.copyObject(this.state.originCountryError);
      if (originCountryError) {
        originCountryError[seat.number] = null;
      }
      this.setState({
        originCountryError: originCountryError,
      });
      let passengerDetailsOnward = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsOnward,
      );
      let passenger = passengerDetailsOnward.find(it => seat.number == it.seatNumber);
      if (passenger) {
        passenger.countryOfOrigin = val;
        this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);
      }
    } catch (e) {
      console.log(e);
    }
  };

  onOriginAddressChange = (val, seat) => {
    try {
      let originAddressError = CommonService.copyObject(this.state.originAddressError);
      if (originAddressError) {
        originAddressError[seat.number] = null;
      }
      this.setState({
        originAddressError: originAddressError,
      });

      let passengerDetailsOnward = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsOnward,
      );
      let passenger = passengerDetailsOnward.find(it => seat.number == it.seatNumber);
      if (passenger) {
        passenger.addressOfOrigin = val;
        this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);
      }
    } catch (e) {
      console.log(e);
    }
  };

  onGenderChange = (val, seat) => {
    try {
      let genderError = CommonService.copyObject(this.state.genderError);
      if (genderError) {
        genderError[seat.number] = null;
      }
      this.setState({
        genderError: genderError,
      });

      let passengerDetailsOnward = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsOnward,
      );
      let passenger = passengerDetailsOnward.find(it => seat.number == it.seatNumber);
      if (passenger) {
        passenger.gender = val;
        this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);
      }
    } catch (e) {
      console.log(e);
    }
  };

  //2nd row inputs onward ended

  //2nd row inputs return starts
  onUserDOBChangeReturn = (text, seat) => {
    try {
      let dobReturnError = CommonService.copyObject(this.state.dobReturnError);
      if (dobReturnError) {
        dobReturnError[seat.number] = null;
      }
      this.setState({
        dobReturnError: dobReturnError,
      });
      let passengerDetailsReturn = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsReturn,
      );
      let passenger = passengerDetailsReturn.find(it => seat.number == it.seatNumber);
      if (passenger) {
        passenger.dob = text;
        this.props.actions.setPassengerDetailsReturn(passengerDetailsReturn);
      }
    } catch (e) {
      console.log(e);
    }
  };

  onOriginCountryChangeReturn = (val, seat) => {
    try {
      let originCountryReturnError = CommonService.copyObject(this.state.originCountryReturnError);
      if (originCountryReturnError) {
        originCountryReturnError[seat.number] = null;
      }
      this.setState({
        originCountryReturnError: originCountryReturnError,
      });

      let passengerDetailsReturn = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsReturn,
      );
      let passenger = passengerDetailsReturn.find(it => seat.number == it.seatNumber);
      if (passenger) {
        passenger.countryOfOrigin = val;
        this.props.actions.setPassengerDetailsReturn(passengerDetailsReturn);
      }
    } catch (e) {
      console.log(e);
    }
  };

  onOriginAddressChangeReturn = (val, seat) => {
    try {
      let originAddressReturnError = CommonService.copyObject(this.state.originAddressReturnError);
      if (originAddressReturnError) {
        originAddressReturnError[seat.number] = null;
      }
      this.setState({
        originAddressReturnError: originAddressReturnError,
      });

      let passengerDetailsReturn = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsReturn,
      );
      let passenger = passengerDetailsReturn.find(it => seat.number == it.seatNumber);
      if (passenger) {
        passenger.addressOfOrigin = val;
        this.props.actions.setPassengerDetailsReturn(passengerDetailsReturn);
      }
    } catch (e) {
      console.log(e);
    }
  };

  onGenderChangeReturn = (val, seat) => {
    try {
      let genderReturnError = CommonService.copyObject(this.state.genderReturnError);
      if (genderReturnError) {
        genderReturnError[seat.number] = null;
      }
      this.setState({
        genderReturnError: genderReturnError,
      });

      let passengerDetailsReturn = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsReturn,
      );
      let passenger = passengerDetailsReturn.find(it => seat.number == it.seatNumber);
      if (passenger) {
        passenger.gender = val;
        this.props.actions.setPassengerDetailsReturn(passengerDetailsReturn);
      }
    } catch (e) {
      console.log(e);
    }
  };

  //2nd row inputs return ended

  onInputBlur = (text, seat, inp) => {
    try {
      // console.log({ text, seat, inp });
      let passengerDetailsOnward = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsOnward,
      );
      let passenger = passengerDetailsOnward.find(it => seat.number == it.seatNumber);
      if (!text) {
        if (inp == 'name') {
          let nameError = CommonService.copyObject(this.state.nameError);
          if (nameError) {
            nameError[seat.number] = {
              message: 'VALIDATIONS.VALID_NAME',
            };
          }
          this.setState({
            nameError: nameError,
          });
        } else if (inp == 'last_name') {
          let last_nameError = CommonService.copyObject(this.state.last_nameError);
          if (last_nameError) {
            last_nameError[seat.number] = {
              message: 'VALIDATIONS.VALID_SURNAME',
            };
          }
          this.setState({
            last_nameError: last_nameError,
          });
        } else if (inp == 'card_number') {
          let cardNumberError = CommonService.copyObject(this.state.cardNumberError);
          if (cardNumberError) {
            cardNumberError[seat.number] = {
              //  message:CommonService.isRut(passenger.idCardType,this.idCardTypes[0]) ? 'Por favor ingrese RUT válido.' : 'Por favor ingrese Pasaporte válido.'
              message: 'VALIDATIONS.VALID_PASSPORT',
            };
          }
          this.setState({
            cardNumberError: cardNumberError,
          });
        }
      }
      if (inp == 'card_number') {
        if (text.trim() === '') {
          return;
        }
        //  if(CommonService.isRut(passenger.idCardType,this.idCardTypes[0])){
        if (!CommonService.isRutValid(passenger.idCardNumber) && passenger.idCardType.value == 7) {
          let cardNumberError = CommonService.copyObject(this.state.cardNumberError);
          if (cardNumberError) {
            cardNumberError[seat.number] = {
              message: 'VALIDATIONS.VALID_RUT_VALID',
            };
          }
          this.setState({
            cardNumberError: cardNumberError,
          });
        }
        passenger.idCardNumber =
          passenger.idCardType.value == 7 ? CommonService.formatRut(text) : text;
        this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);
        //  }

        if (text.trim() !== '') {
          this.operator &&
            this.operator.operator_name != 'fernandez' &&
            this.getPassengerDetailsInfo({
              passenger,
              text,
              passengerDetailsData: passengerDetailsOnward,
              setPassengerDetailsFunc: this.props.actions.setPassengerDetailsOnward,
            });
        }
      }
      if (this.isAllInputsValid()) {
        this.checkCorporateDiscount();
        this.callInstantDiscountAPI();
      }
    } catch (e) {
      console.log(e);
    }
  };
  callInstantDiscountAPI = () => {
    // console.log('callInstantDiscountAPI', this.props);
    let data = {
      ...this.props.home,
      ...this.props.pbServiceList,
      ...this.props.pbPaymentDetails,
    };

    //GET INSTANT DISCOUNT IF ANY
    let onward_seats_info = [];
    if (data.passengerDetailsOnward && data.passengerDetailsOnward.length) {
      for (let s of data.passengerDetailsOnward) {
        onward_seats_info.push({
          seat_no: (s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + '',
          seat_fare: s.fare,
          id_type: s.idCardType.value,
          id_value: s.idCardNumber,
        });
      }
    }

    let return_seats_info = [];
    if (data.passengerDetailsReturn && data.passengerDetailsReturn.length) {
      for (let s of data.passengerDetailsReturn) {
        return_seats_info.push({
          seat_no: (s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + '',
          seat_fare: s.fare,
          id_type: s.idCardType.value,
          id_value: s.idCardNumber,
        });
      }
    }

    let instantData = {
      amount:
        this.props.pbServiceList.bookingDetailsOnward &&
        this.props.pbServiceList.bookingDetailsOnward.netBookingAmount,
      travel_date: DateService.getTodayString('yyyy-mm-dd'),
      // origin_id:
      //   this.props.pbServiceList.selectedService &&
      //   this.props.pbServiceList.selectedService.origin.id,
      // destination_id:
      //   this.props.pbServiceList.selectedService &&
      //   this.props.pbServiceList.selectedService.destination.id,
      origin_id: data.pbSourceCity && data.pbSourceCity.value,
      destination_id: data.pbDestinationCity && data.pbDestinationCity.value,
      travel_id:
        this.props.pbServiceList.selectedService &&
        this.props.pbServiceList.selectedService.travel_id,
      is_mobile_app: 'true',
      is_round_trip: data.returnPBDate ? true : false,
      depart_time:
        this.props.pbServiceList.selectedService &&
        this.props.pbServiceList.selectedService.boarding_stages[0].time,
      onward_seats_info,
      return_seats_info:
        return_seats_info && return_seats_info.length > 0 ? return_seats_info : null,
    };

    if (this.props.common.loginData) {
      instantData.customer_id = this.props.common.loginData ? this.props.common.loginData.id : null;
    }

    this.props.actions
      .apiCall({
        url: ApiUrls.applyInstantDiscount(),
        type: 'home',
        method: 'POST',
        data: instantData,
      })
      .then(
        res => this.onInstantDiscountApply(res),
        err => console.log('Error from check instant discount-----', err),
      );
  };

  onInstantDiscountApply = res => {
    // console.log('Result from instant discount application------', res);
    if (res && res.data && res.data.status === 200) {
      this.setState({ instantDiscount: res.data });
    } else {
      this.setState({ instantDiscount: null });
    }
  };

  checkCorporateDiscount = () => {
    let data = {
      ...this.props.home,
      ...this.props.pbServiceList,
      ...this.props.pbPaymentDetails,
    };

    let discountData = {
      amount: this.calculateNetFare(),
      travel_date: data.onwardPBDate,
      origin_id: data.pbSourceCity && data.pbSourceCity.value,
      destination_id: data.pbDestinationCity && data.pbDestinationCity.value,
      travel_id:
        data.selectedServiceOnward && data.selectedServiceOnward.route
          ? data.selectedServiceOnward.route.travel_id
          : null,
      is_mobile_app: 'true',
      is_round_trip: data.returnPBDate ? true : false,
      depart_time:
        data.selectedServiceOnward && data.selectedServiceOnward.route
          ? data.selectedServiceOnward.route.arr_time
          : null,
      customer_id: this.props.common.loginData && this.props.common.loginData.id,
      email:
        this.props.pbPaymentDetails.contactDetails &&
        this.props.pbPaymentDetails.contactDetails.email,
      onward_seats_info: [],
      return_seats_info: [],
    };
    let onwardSeatInfo = [];
    if (data.passengerDetailsOnward && data.passengerDetailsOnward.length) {
      for (let s of data.passengerDetailsOnward) {
        onwardSeatInfo.push({
          seat_no: (s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + '',
          seat_fare: s.fare,
          id_type: s.idCardType.value,
          id_value: s.idCardNumber,
        });
      }
    }
    let returnSeatInfo = [];
    if (data.passengerDetailsReturn && data.passengerDetailsReturn.length) {
      for (let s of data.passengerDetailsReturn) {
        returnSeatInfo.push({
          seat_no: (s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + '',
          seat_fare: s.fare,
          id_type: s.idCardType.value,
          id_value: s.idCardNumber,
        });
      }
    }
    discountData.onward_seats_info = onwardSeatInfo;
    discountData.return_seats_info = returnSeatInfo;
    this.props.actions
      .checkCorporateDiscount({
        url: ApiUrls.applyCorporateDiscount(data.returnPBDate),
        data: discountData,
      })
      .then(res => {
        // console.log(res);
        if (res.status === 200) {
          this.setState({ corporateDiscountState: res });
        } else {
          this.setState({ corporateDiscountState: null });
        }
      });
  };

  isAllInputsValid = () => {
    let errorCount = 0;
    let passengerDetailsOnward = CommonService.copyObject(
      this.props.pbPaymentDetails.passengerDetailsOnward,
    );
    let passengerDetailsReturn = CommonService.copyObject(
      this.props.pbPaymentDetails.passengerDetailsReturn,
    );
    let contactDetails = CommonService.copyObject(this.props.pbPaymentDetails.contactDetails);
    if (!contactDetails.email) {
      errorCount++;
    } else if (!CommonService.isEMailValid(contactDetails.email)) {
      errorCount++;
    }
    for (let p of passengerDetailsOnward) {
      if (!p.name) {
        errorCount++;
      }
      if (!p.last_name) {
        errorCount++;
      }
      if (!p.idCardNumber) {
        errorCount++;
      }

      if (!p.last_name) {
        errorCount++;
      }
    }
    if (this.props.home.returnPBDate) {
      for (let p of passengerDetailsReturn) {
        if (!p.name) {
          errorCount++;
        }
        if (!p.last_name) {
          errorCount++;
        }

        if (!p.idCardNumber) {
          errorCount++;
        } else {
          if (
            // p.nationality.id == 1 &&
            !CommonService.isRutValid(p.idCardNumber) &&
            p.idCardType.value == 7
          ) {
            errorCount++;
          }
        }
      }
    }

    if (errorCount > 0) {
      return false;
    }
    return true;
  };

  onInputBlurReturn = (text, seat, inp) => {
    try {
      // console.log(text, seat, inp);
      let passengerDetailsReturn = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsReturn,
      );
      let passenger = passengerDetailsReturn.find(it => seat.number == it.seatNumber);
      if (!text) {
        if (inp == 'name') {
          let nameReturnError = CommonService.copyObject(this.state.nameReturnError);
          if (nameReturnError) {
            nameReturnError[seat.number] = {
              message: 'VALIDATIONS.VALID_NAME',
            };
          }
          this.setState({
            nameReturnError: nameReturnError,
          });
        } else if (inp == 'last_name') {
          let last_nameReturnError = CommonService.copyObject(this.state.last_nameReturnError);
          if (last_nameReturnError) {
            last_nameReturnError[seat.number] = {
              message: 'VALIDATIONS.VALID_SURNAME',
            };
          }
          this.setState({
            last_nameReturnError: last_nameReturnError,
          });
        } else if (inp == 'card_number') {
          let cardNumberReturnError = CommonService.copyObject(this.state.cardNumberReturnError);
          if (cardNumberReturnError) {
            cardNumberReturnError[seat.number] = {
              message: 'VALIDATIONS.VALID_PASSPORT',
            };
          }
          this.setState({
            cardNumberReturnError: cardNumberReturnError,
          });
        }
      }
      if (inp == 'card_number') {
        if (text.trim() === '') {
          return;
        }
        //  if(CommonService.isRut(passenger.idCardType,this.idCardTypes[0])){
        if (!CommonService.isRutValid(passenger.idCardNumber) && passenger.idCardType.value == 7) {
          let cardNumberReturnError = CommonService.copyObject(this.state.cardNumberReturnError);
          if (cardNumberReturnError) {
            cardNumberReturnError[seat.number] = {
              message: 'VALIDATIONS.VALID_RUT_VALID',
            };
          }
          this.setState({
            cardNumberReturnError: cardNumberReturnError,
          });
        }
        passenger.idCardNumber =
          passenger.idCardType.value == 7 ? CommonService.formatRut(text) : text;
        this.props.actions.setPassengerDetailsReturn(passengerDetailsReturn);
        //  }

        if (text !== '') {
          this.operator &&
            this.operator.operator_name != 'fernandez' &&
            this.getPassengerDetailsInfo({
              passenger,
              text,
              passengerDetailsData: passengerDetailsReturn,
              setPassengerDetailsFunc: this.props.actions.setPassengerDetailsReturn,
            });
        }
      }
      if (this.isAllInputsValid()) {
        this.checkCorporateDiscount();
        this.callInstantDiscountAPI();
      }
    } catch (e) {
      console.log(e);
    }
  };

  getPassengerDetailsInfo = ({
    passenger,
    text,
    passengerDetailsData,
    setPassengerDetailsFunc,
  }) => {
    this.props.actions
      .getPassengerInfo({
        url: ApiUrls.getPassengerInfo({
          cardType: passenger.idCardType.value,
          idCardNumber: text && text.replace(/[\.\-]/g, ''),
        }),
      })
      .then(res => {
        // console.log('res', res);
        if (res && res.data && res.data.success && res.data.body) {
          let contactDetails = CommonService.copyObject(this.props.pbPaymentDetails.contactDetails);
          if (!contactDetails.mobile || res.data.body.phone) {
            let number = CommonService.onlyNumbers(res.data.body.phone);
            contactDetails.mobile = number;
            this.setState({
              mobileError: null,
            });
          }
          if (!contactDetails.email || res.data.body.email) {
            contactDetails.email = res.data.body.email;
            this.setState({
              emailError: null,
            });
          }
          if (!contactDetails.confirmEmail || res.data.body.email) {
            contactDetails.confirmEmail = res.data.body.email;
            this.setState({
              confirmEmailError: null,
            });
          }
          this.props.actions.setContactDetails(contactDetails);

          if (res.data.body.name) {
            passenger.name = res.data.body.name;
          }
          if (res.data.body.name) {
            passenger.name = res.data.body.name.split('_')[0];
            passenger.last_name = res.data.body.name.split('_')[1]
              ? res.data.body.name.split('_')[1]
              : passenger.last_name;

            this.setState({
              nameError: '',
              last_nameError: '',
              nameReturnError: '',
              last_nameReturnError: '',
            });
          }
          setPassengerDetailsFunc(passengerDetailsData);
          setTimeout(() => {
            if (this.isAllInputsValid()) {
              this.checkCorporateDiscount();
              this.callInstantDiscountAPI();
            }
          }, 1000);
        }
      });
  };

  copyToReturn = () => {
    try {
      let filteredData = [];

      for (let v1 in this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook) {
        for (let v2 in this.props.pbPaymentDetails.passengerDetailsReturn) {
          if (
            this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook[v1].number ===
              this.props.pbPaymentDetails.passengerDetailsReturn[v2].seatNumber &&
            !this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook[v1].is_pet_seat
          ) {
            filteredData.push(this.props.pbPaymentDetails.passengerDetailsReturn[v2]);
          }
        }
      }

      // console.log(
      //   '<==========================================yes================================>',
      //   this.props.pbPaymentDetails.passengerDetailsReturn,
      //   this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook,
      // );
      let passReturn = CommonService.copyObject(this.props.pbPaymentDetails.passengerDetailsReturn);
      if (!this.state.copyToReturnChecked) {
        for (let i = 0; i < this.props.pbPaymentDetails.passengerDetailsReturn.length; i++) {
          if (passReturn[i] && this.props.pbPaymentDetails.passengerDetailsOnward[i]) {
            passReturn[i].name = this.props.pbPaymentDetails.passengerDetailsOnward[i].name;
            passReturn[i].last_name = this.props.pbPaymentDetails.passengerDetailsOnward[
              i
            ].last_name;
            passReturn[i].nationality = this.props.pbPaymentDetails.passengerDetailsOnward[
              i
            ].nationality;
            passReturn[i].idCardType = this.props.pbPaymentDetails.passengerDetailsOnward[
              i
            ].idCardType;
            passReturn[i].idCardNumber = this.props.pbPaymentDetails.passengerDetailsOnward[
              i
            ].idCardNumber;

            //2nd row
            passReturn[i].dob = this.props.pbPaymentDetails.passengerDetailsOnward[i].dob;
            passReturn[i].countryOfOrigin = this.props.pbPaymentDetails.passengerDetailsOnward[
              i
            ].countryOfOrigin;
            passReturn[i].addressOfOrigin = this.props.pbPaymentDetails.passengerDetailsOnward[
              i
            ].addressOfOrigin;
            passReturn[i].gender = this.props.pbPaymentDetails.passengerDetailsOnward[i].gender;

            this.setIdTypes(3, i);
            this.onNameChangeReturn(passReturn[i].name, { number: passReturn[i].seatNumber });
            this.onIdCardNumberChangeReturn(passReturn[i].idCardNumber, {
              number: passReturn[i].seatNumber,
            });
          }
        }
      } else {
        let i = 0;
        for (let p of passReturn) {
          p.name = '';
          p.last_name = '';
          p.nationality = this.countries[0];
          p.idCardType = this.idCardTypes[0];
          p.idCardNumber = '';
          p.dob = '';
          p.countryOfOrigin = {};
          p.addressOfOrigin = '';
          p.gender = {};
          this.setIdTypes(3, i);
          this.onNameChangeReturn(p.name, { number: p.seatNumber });
          this.onIdCardNumberChangeReturn(p.idCardNumber, { number: p.seatNumber });
          i++;
        }
      }
      for (let v1 in this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook) {
        for (let v2 in this.props.pbPaymentDetails.passengerDetailsReturn) {
          if (
            this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook[v1].number ===
              this.props.pbPaymentDetails.passengerDetailsReturn[v2].seatNumber &&
            this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook[v1].is_pet_seat
          ) {
            passReturn.push(this.props.pbPaymentDetails.passengerDetailsReturn[v2]);
          }
        }
      }
      this.setState({
        copyToReturnChecked: !this.state.copyToReturnChecked,
        idCardTypesReturn: this.idCardTypesReturn,
      });
      this.props.actions.setPassengerDetailsReturn(passReturn);
      setTimeout(() => {
        if (this.isAllInputsValid()) {
          this.checkCorporateDiscount();
          this.callInstantDiscountAPI();
        }
      }, 150);
    } catch (e) {
      console.log(e);
    }
  };

  hasPetSeat = () => {
    for (let seat of this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook) {
      if (seat.is_pet_seat) {
        return true;
      }
    }
    for (let seat of this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook) {
      if (seat.is_pet_seat) {
        return true;
      }
    }
  };

  setIdTypes(idType, i) {
    // let cardTypes = [];
    // for(let c in this.props.data.metaData.id_card_types){
    //     cardTypes.push({
    //         value:this.props.data.metaData.id_card_types[c],
    //         id:this.props.data.metaData.id_card_types[c],
    //         label:c,
    //         name:c,
    //         selected: this.props.data.metaData.id_card_types[c] == idType
    //     });
    // }
    this.idCardTypesReturn[i] = idType;
  }

  onSubmit = () => {
    try {
      let contactDetails = CommonService.copyObject(this.props.pbPaymentDetails.contactDetails);
      let mobileError = null;
      let emailError = null;
      let confirmEmailError = null;

      let passengerDetailsOnward = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsOnward,
      );
      let passengerDetailsReturn = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsReturn,
      );
      let nameError = CommonService.copyObject(this.state.nameError);
      let last_nameError = CommonService.copyObject(this.state.last_nameError);
      let cardNumberError = CommonService.copyObject(this.state.cardNumberError);
      let nameReturnError = CommonService.copyObject(this.state.nameReturnError);
      let last_nameReturnError = CommonService.copyObject(this.state.last_nameReturnError);
      let cardNumberReturnError = CommonService.copyObject(this.state.cardNumberReturnError);
      let dobError = CommonService.copyObject(this.state.dobError);
      let dobReturnError = CommonService.copyObject(this.state.dobReturnError);
      let originCountryError = CommonService.copyObject(this.state.originCountryError);
      let originCountryReturnError = CommonService.copyObject(this.state.originCountryReturnError);
      let originAddressError = CommonService.copyObject(this.state.originAddressError);
      let originAddressReturnError = CommonService.copyObject(this.state.originAddressReturnError);
      let genderError = CommonService.copyObject(this.state.genderError);
      let genderReturnError = CommonService.copyObject(this.state.genderReturnError);

      let errorCount = 0;

      let onwardPassenger;

      for (let seat of this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook) {
        if (seat.is_pet_seat) {
          let onwardPassenger = passengerDetailsOnward.find(
            it => seat.associated_seat == it.seatNumber,
          );
          let passenger2 = passengerDetailsOnward.find(it => seat.number == it.seatNumber);
          if (passenger2) {
            passenger2.name = onwardPassenger.name;
            passenger2.last_name = onwardPassenger.last_name;
            passenger2.nationality = onwardPassenger.nationality;
            passenger2.idCardType = onwardPassenger.idCardType;
            passenger2.idCardNumber = onwardPassenger.idCardNumber;
            this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);
          }
        }
      }

      if (this.props.home.returnPBDate) {
        for (let seat of this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook) {
          if (seat.is_pet_seat) {
            let passenger2 = passengerDetailsReturn.find(it => seat.number == it.seatNumber);
            let passenger = passengerDetailsReturn.find(
              it => seat.associated_seat == it.seatNumber,
            );
            if (passenger2) {
              passenger2.name = passenger ? passenger.name : onwardPassenger.name;
              passenger2.last_name = passenger ? passenger.last_name : onwardPassenger.last_name;
              passenger2.nationality = passenger
                ? passenger.nationality
                : onwardPassenger.nationality;
              passenger2.idCardType = passenger ? passenger.idCardType : onwardPassenger.idCardType;
              passenger2.idCardNumber = passenger
                ? passenger.idCardNumber
                : onwardPassenger.idCardNumber;
              this.props.actions.setPassengerDetailsReturn(passengerDetailsReturn);
            }
          }
        }
      }

      if (!contactDetails.mobile) {
        mobileError = {
          message: 'VALIDATIONS.VALID_MOBILE',
        };
        errorCount++;
      }
      if (!contactDetails.email) {
        emailError = {
          message: 'VALIDATIONS.VALID_EMAIL',
        };
        errorCount++;
      } else if (!CommonService.isEMailValid(contactDetails.email)) {
        emailError = {
          message: 'VALIDATIONS.VALID_EMAIL_VALIDATION',
        };
        errorCount++;
      }
      if (contactDetails.confirmEmail != contactDetails.email) {
        confirmEmailError = {
          message: 'VALIDATIONS.VALID_EMAIL_MATCH',
        };
        errorCount++;
      }
      if (!contactDetails.confirmEmail) {
        confirmEmailError = {
          message: 'VALIDATIONS.VALID_CONFIRM_EMAIL',
        };
        errorCount++;
      }
      if (this.state.promoCodeChecked) {
        if (!this.state.promoCode) {
          errorCount++;
          this.setState({
            promoCodeError: {
              message: 'VALIDATIONS.VALID_PROMOTION',
            },
          });
        }
      }
      for (let p of passengerDetailsOnward) {
        // console.log('individual Passenger is-----', p);
        // console.log('individual State is-----', this.state);
        if (!p.name) {
          if (nameError) {
            nameError[p.seatNumber] = {
              message: 'VALIDATIONS.VALID_NAME',
            };
          }
          errorCount++;
        }
        if (!p.last_name) {
          if (last_nameError) {
            last_nameError[p.seatNumber] = {
              message: 'VALIDATIONS.VALID_LAST_NAME',
            };
          }
          errorCount++;
        }
        if (!p.idCardNumber) {
          if (cardNumberError) {
            cardNumberError[p.seatNumber] = {
              message:
                p.idCardType && p.idCardType.value == 7
                  ? this.props.t('VALIDATIONS.VALID_RUT')
                  : this.props.t('VALIDATIONS.VALID_PASSPORT'),
            };
          }
          errorCount++;
        }

        if (!p.last_name) {
          if (last_nameError) {
            last_nameError[p.seatNumber] = {
              message: 'VALIDATIONS.VALID_SURNAME',
            };
          }
          errorCount++;
        }

        if (cardNumberError[p.seatNumber]) {
          errorCount++;
          // console.log('card type errorssssssss');
        }

        if (this.state.internationalService && !p.dob) {
          if (dobError) {
            dobError[p.seatNumber] = {
              message: this.props.t('VALIDATIONS.DOB_ERROR'),
            };
          }
          errorCount++;
        }

        if (this.state.internationalService && !p.countryOfOrigin) {
          // console.log('inside country of origin');
          if (originCountryError) {
            originCountryError[p.seatNumber] = {
              message: this.props.t('VALIDATIONS.ORIGIN_COUNTRY_ERROR'),
            };
          }
          errorCount++;
        }

        if (this.state.internationalService && !p.addressOfOrigin) {
          // console.log('inside address of origin');
          if (originAddressError) {
            originAddressError[p.seatNumber] = {
              message: this.props.t('VALIDATIONS.ORIGIN_ADDRESS_ERROR'),
            };
          }
          errorCount++;
        }

        if (this.state.internationalService && !p.gender) {
          // console.log('inside gender');
          if (genderError) {
            genderError[p.seatNumber] = {
              message: this.props.t('VALIDATIONS.GENDER_ERROR'),
            };
          }
          errorCount++;
        }
      }
      if (this.props.home.returnPBDate) {
        for (let p of passengerDetailsReturn) {
          if (!p.name) {
            if (nameReturnError) {
              nameReturnError[p.seatNumber] = {
                message: 'VALIDATIONS.VALID_NAME',
              };
            }
            errorCount++;
          }
          if (!p.last_name) {
            if (last_nameReturnError) {
              last_nameReturnError[p.seatNumber] = {
                message: 'VALIDATIONS.VALID_SURNAME',
              };
            }
            errorCount++;
          }

          if (this.state.internationalService && !p.gender) {
            // console.log('inside gender');
            if (genderReturnError) {
              genderReturnError[p.seatNumber] = {
                message: this.props.t('VALIDATIONS.GENDER_ERROR'),
              };
            }
            errorCount++;
          }

          if (this.state.internationalService && !p.addressOfOrigin) {
            // console.log('inside return address');
            if (originAddressReturnError) {
              originAddressReturnError[p.seatNumber] = {
                message: this.props.t('VALIDATIONS.ORIGIN_ADDRESS_ERROR'),
              };
            }
            errorCount++;
          }

          if (this.state.internationalService && !p.dob) {
            if (dobReturnError) {
              dobReturnError[p.seatNumber] = {
                message: this.props.t('VALIDATIONS.DOB_ERROR'),
              };
            }
            errorCount++;
          }

          if (this.state.internationalService && !p.countryOfOrigin) {
            // console.log('inside country of origin');
            if (originCountryReturnError) {
              originCountryReturnError[p.seatNumber] = {
                message: this.props.t('VALIDATIONS.ORIGIN_COUNTRY_ERROR'),
              };
            }
            errorCount++;
          }

          if (!p.idCardNumber) {
            if (cardNumberReturnError) {
              cardNumberReturnError[p.seatNumber] = {
                message:
                  p.idCardType && p.idCardType.value == 7
                    ? this.props.t('VALIDATIONS.VALID_RUT')
                    : this.props.t('VALIDATIONS.VALID_PASSPORT'),
              };
            }
            errorCount++;
          } else {
            if (
              // p.nationality.id == 1 &&
              !CommonService.isRutValid(p.idCardNumber) &&
              p.idCardType.value == 7
            ) {
              if (cardNumberReturnError) {
                cardNumberReturnError[p.seatNumber] = {
                  message:
                    p.idCardType == 7
                      ? this.props.t('VALIDATIONS.VALID_RUT')
                      : this.props.t('VALIDATIONS.VALID_PASSPORT'),
                };
              }
              errorCount++;
            }
          }

          if (cardNumberReturnError[p.seatNumber]) {
            errorCount++;
          }
        }
      }
      this.setState({
        mobileError: mobileError,
        emailError: emailError,
        confirmEmailError: confirmEmailError,
        nameError: nameError,
        last_nameError: last_nameError,
        cardNumberError: cardNumberError,
        nameReturnError: nameReturnError,
        cardNumberReturnError: cardNumberReturnError,
        dobError: dobError,
        dobReturnError: dobReturnError,
        originCountryError: originCountryError,
        originCountryReturnError: originCountryReturnError,
        originAddressError: originAddressError,
        originAddressReturnError: originAddressReturnError,
        genderError: genderError,
        genderReturnError: genderReturnError,
      });
      if (!this.state.tncChecked) {
        errorCount++;
      }
      if (!this.state.selectedPaymentGateway && this.calculateNetFare() > 0) {
        errorCount++;
      }
      if (errorCount <= 0) {
        setTimeout(() => {
          this.pay();
        }, 350);
      }
    } catch (e) {
      console.log(e);
    }
  };

  getSelectedPetSeatPairs = selectedSeats => {
    let petSeats = [];
    if (selectedSeats && selectedSeats.length) {
      for (let seat of selectedSeats) {
        if (seat.is_pet_seat) {
          petSeats.push([seat.number, seat.associated_seat]);
        }
      }
      return petSeats;
    }
    return null;
  };

  callGTMForDataPush = (data, pnr = null) => {
    if (this.props.home.operator && this.props.home.operator.operator_name.includes('andimar')) {
      console.log('selectedServiceOnward is---', data.selectedServiceOnward);

      const totalAmount = data.bookingDetailsOnward.netBookingAmount;
      const cityPair = `${data.pbSourceCity.label} - ${data.pbDestinationCity.label}`;
      const terminalPair = `${data.selectedServiceOnward.boardingStage.landmark} - ${data.selectedServiceOnward.droppingStage.landmark}`;
      const selectedSeat = Object.keys(data.bookingDetailsOnward.selectedSeatTypes)[0];
      const indFare = Object.values(data.bookingDetailsOnward.selectedSeatTypes)[0][0].fare;

      let gtmData = {
        event: pnr ? 'purchase' : 'add_to_cart',
        currency: 'CLP',
        value: totalAmount,
        items: [
          {
            item_name: cityPair,
            price: indFare,
            quantity: data.passengerDetailsOnward.length,
            item_category: selectedSeat,
            item_category2: terminalPair,
          },
        ],
      };
      if (pnr) {
        gtmData['transaction_id'] = pnr;
      }
      window.dataLayer.push(gtmData);

      if (data.passengerDetailsReturn && data.passengerDetailsReturn.length) {
        const totalAmount = data.bookingDetailsReturn.netBookingAmount;
        const cityPair = `${data.pbDestinationCity.label} - ${data.pbSourceCity.label}`;
        const terminalPair = `${data.selectedServiceReturn.boardingStage.landmark} - ${data.selectedServiceReturn.droppingStage.landmark}`;
        const selectedSeat = Object.keys(data.bookingDetailsReturn.selectedSeatTypes)[0];
        const indFare = Object.values(data.bookingDetailsReturn.selectedSeatTypes)[0][0].fare;

        let gtmData = {
          event: pnr ? 'purchase' : 'add_to_cart',
          currency: 'CLP',
          value: totalAmount,
          items: [
            {
              item_name: cityPair,
              price: indFare,
              quantity: data.passengerDetailsOnward.length,
              item_category: selectedSeat,
              item_category2: terminalPair,
            },
          ],
        };
        if (pnr) {
          gtmData['transaction_id'] = pnr;
        }
        window.dataLayer.push(gtmData);
      }
    }
  };

  pay = () => {
    // console.log('opertor details--', this.props.home.operator, this.state);
    this.setState({ isLoading: true });
    try {
      let data = {
        ...this.props.home,
        ...this.props.pbServiceList,
        ...this.props.pbPaymentDetails,
      };

      //   let bookingJson = {
      //     title: {},
      //     passenger_name: {},
      //     passenger_age: {},
      //     id_card: {},
      //     fare: {},
      //     nationality: {},
      //     dob: {},
      //     origin_country: {},
      //     origin_address: {},
      //     gender: {},
      //     cash_coupon: {
      //       coupon_code: '',
      //       email: '',
      //     },
      //     primary:
      //       (data.passengerDetailsOnward[0].floorNo
      //         ? data.passengerDetailsOnward[0].floorNo + '_'
      //         : '') + data.passengerDetailsOnward[0].seatNumber,
      //     promo_code: this.state.promoCodeApplied ? this.state.promoCode : null,
      //     bima_onward_amount: data.bookingDetailsOnward.netBookingAmount,
      //     bima_return_amount: data.bookingDetailsReturn.netBookingAmount,
      //     net_amount: this.calculateNetFare(),
      //     selected_seats: data.bookingDetailsOnward.selectedSeatsNumbers,
      //     selected_seats_r: data.bookingDetailsReturn.selectedSeatsNumbers
      //       ? data.bookingDetailsReturn.selectedSeatsNumbers
      //       : null,
      //     number_of_seats: data.passengerDetailsOnward.length,
      //     number_of_seats_r:
      //       data.passengerDetailsReturn && data.passengerDetailsReturn.length
      //         ? data.passengerDetailsReturn.length
      //         : null,
      //     boarding_at: data.selectedServiceOnward.boardingStage.id,
      //     return_boarding_at: data.selectedServiceReturn.boardingStage
      //       ? data.selectedServiceReturn.boardingStage.id
      //       : null,
      //     drop_off: data.selectedServiceOnward.droppingStage.id,
      //     return_drop_off: data.selectedServiceReturn.droppingStage
      //       ? data.selectedServiceReturn.droppingStage.id
      //       : null,
      //     reservation_id: data.selectedServiceOnward.route.id,
      //     return_reservation_id: data.selectedServiceReturn.route
      //       ? data.selectedServiceReturn.route.id
      //       : null,
      //     from: data.pbSourceCity.value,
      //     to: data.pbDestinationCity.value,
      //     origin_name: data.pbSourceCity.label,
      //     destination_name: data.pbDestinationCity.label,
      //     type: '1',
      //     depart: data.onwardPBDate,
      //     return: data.returnPBDate,
      //     is_charity: '0',
      //     referral_url: '',
      //     offer_coupon_details: null,
      //     email: data.contactDetails.email,
      //     phone_number: data.contactDetails.mobile,
      //     pay_gay_type: this.props.home.is_mot ? 45 : this.state.selectedPaymentGateway,
      //     payment_mode: this.state.payment_mode,
      //     country_code: data.contactDetails.countryCode,
      //     is_mobile_web: 3,
      //     // use_wallet_money: this.state.wallet,
      //     // use_virtual_money: this.state.virtual,
      //     use_wallet_money: false,
      //     use_virtual_money: false,
      //     // "device_details": this.props.data.deviceInfo,
      //     is_kupos: true,
      //     kupos_r_url: window.location.protocol + '//' + window.location.host,
      //     one_click_details: {
      //       card_no:
      //         this.state.cardChecked && this.state.selectedCard
      //           ? this.state.selectedCard[0].substr(12, 15)
      //           : '',
      //       // card_cat:
      //       //   this.state.cardChecked && this.state.selectedCard ? this.state.selectedCard[1] : 0,
      //       card_type:
      //         this.state.cardChecked && this.state.selectedCard ? this.state.selectedCard[2] : 0,
      //     },
      //     iframe_operator_id: this.iframe_operator_id,
      //     referral_code: this.referral_code,
      //     operator_id: this.operator && this.operator.operator_id ? this.operator.operator_id : null,

      //     selected_pet_seats: this.getSelectedPetSeatPairs(
      //       this.props.pbServiceList.bookingDetailsOnward &&
      //         this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook,
      //     ),
      //     selected_pet_seats_r: this.getSelectedPetSeatPairs(
      //       this.props.pbServiceList.bookingDetailsReturn &&
      //         this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook,
      //     ),
      //   };

      //   if (this.props.home.is_mot && this.state.motData) {
      //     bookingJson['mot_amount'] = this.state.motData.mot_amount;
      //     bookingJson['mot_discounted_amount'] =
      //       this.originalBaseFare() - this.state.motData.mot_amount;
      //     bookingJson['mot_id'] = this.state.motData.mot_id;
      //     bookingJson['mot_code'] = this.state.motData.mot_code;
      //     bookingJson['total_base_fare'] = data.bookingDetailsOnward.netBookingAmount;
      //   }

      //   if (this.state.instantDiscount && !this.state.corporateDiscountState) {
      //     bookingJson.is_instant_promo = true;
      //     bookingJson.instant_discount = this.state.instantDiscount.discount_amount;
      //     bookingJson.instant_discount_id = this.state.instantDiscount.instant_discount_id;
      //   }

      //   if (this.state.corporateDiscountState && !this.state.instantDiscount) {
      //     bookingJson.corporate_company_id = this.state.corporateDiscountState.corporate_company_id;
      //     bookingJson.corporate_discount = this.state.corporateDiscountState.discount_amount;
      //   }

      //   if (this.state.corporateDiscountState && this.state.instantDiscount) {
      //     if (
      //       this.state.corporateDiscountState.discount_amount >
      //       this.state.instantDiscount.discount_amount
      //     ) {
      //       bookingJson.corporate_company_id = this.state.corporateDiscountState.corporate_company_id;
      //       bookingJson.corporate_discount = this.state.corporateDiscountState.discount_amount;
      //     } else {
      //       bookingJson.is_instant_promo = true;
      //       bookingJson.instant_discount = this.state.instantDiscount.discount_amount;
      //       bookingJson.instant_discount_id = this.state.instantDiscount.instant_discount_id;
      //     }
      //   }

      // console.log({ bookingJson })

      //   for (let s of data.passengerDetailsOnward) {
      //     bookingJson.title[(s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''] = 'Mr';
      //     bookingJson.passenger_name[(s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''] =
      //       s.name + '_' + s.last_name;
      //     bookingJson.passenger_age[(s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''] = '35';
      //     bookingJson.id_card[(s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''] = {
      //       type: s.idCardType.value,
      //       number: s.idCardNumber,
      //     };
      //     bookingJson.fare[(s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''] = s.fare;
      //     bookingJson.nationality[(s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''] =
      //       s.nationality.value + '';
      //     //new values
      //     bookingJson.dob[(s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''] = s.dob
      //       ? s.dob
      //       : null;
      //     bookingJson.origin_country[
      //       (s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''
      //     ] = s.countryOfOrigin ? s.countryOfOrigin.value : null;
      //     bookingJson.origin_address[
      //       (s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''
      //     ] = s.addressOfOrigin ? s.addressOfOrigin : null;
      //     bookingJson.gender[(s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''] = s.gender
      //       ? s.gender.value
      //       : null;
      //   }
      //   if (data.passengerDetailsReturn && data.passengerDetailsReturn.length) {
      //     let i = 0;
      //     for (let s of data.passengerDetailsReturn) {
      //       if (i === 0) {
      //         bookingJson.title.r = {};
      //         bookingJson.passenger_name.r = {};
      //         bookingJson.passenger_age.r = {};
      //         bookingJson.id_card.r = {};
      //         bookingJson.fare.r = {};
      //         bookingJson.nationality.r = {};
      //         bookingJson.dob.r = {};
      //         bookingJson.origin_country.r = {};
      //         bookingJson.origin_address.r = {};
      //         bookingJson.gender.r = {};
      //       }
      //       bookingJson.title.r[(s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''] = 'Mr';
      //       bookingJson.passenger_name.r[(s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''] =
      //         s.name + '_' + s.last_name;
      //       bookingJson.passenger_age.r[(s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''] =
      //         '25';
      //       bookingJson.id_card.r[(s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''] = {
      //         type: s.idCardType.value,
      //         number: s.idCardNumber,
      //       };
      //       bookingJson.fare.r[(s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''] = s.fare;
      //       bookingJson.nationality.r[(s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''] =
      //         s.nationality.value + '';
      //       //new values
      //       bookingJson.dob.r[(s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''] = s.dob
      //         ? s.dob
      //         : null;
      //       bookingJson.origin_country.r[
      //         (s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''
      //       ] = s.countryOfOrigin ? s.countryOfOrigin.value : null;
      //       bookingJson.origin_address.r[
      //         (s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''
      //       ] = s.addressOfOrigin ? s.addressOfOrigin : null;
      //       bookingJson.gender.r[(s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''] = s.gender
      //         ? s.gender.value
      //         : null;
      //       i++;
      //     }
      //   }
      // this.props.setBookingJSONDetails(bookingJson);

      // gtag ecommerce event checkout function
      //   this.callGTMForDataPush(data);

      //todo call gtm

      //   console.log('Booking JSOn', bookingJson);
      // return;

      CommonService.passengerDetailsOnward = null;
      CommonService.passengerContactDetails = null;
      CommonService.passengerDetailsReturn = null;

      //   bookingJson.trip_type = data.returnPBDate ? 'roundtrip' : 'tentative';

      //   this.props.actions
      //     .bookTicket({ url: ApiUrls.bookTicketV2(), data: bookingJson })
      //     .then(res => {
      //       localStorage.setItem('appType', CommonService.isTrain() ? 'train' : 'bus');
      //       console.log('Response from booking updated-------------', res);

      //       if (
      //         res &&
      //         res.data &&
      //         res.data.pnr_number &&
      //         res.data.html_str &&
      //         !res.data.invalid_seat_fare_hash
      //       ) {
      //         this.callGTMForDataPush(data, res.data.pnr_number);
      //         localStorage.setItem('paymentGatewayOpened', true);
      //         document.write(res.data.html_str);
      //       } else if (res && res.data && res.data.redirect_url) {
      //         this.callGTMForDataPush(data, res.data.pnr_number);
      //         if (res.data.status == 'confirmed') {
      //           window.location.href = `${res.data.callback_url}?pnr_number=${res.data.pnr_number}&payment_refeference=${res.data.payment_refeference}`;
      //         } else {
      //           window.location.href = res.data.redirect_url;
      //         }
      //       } else if (res && res.data && res.data.invalid_seat_fare_hash) {
      //         this.setState({
      //           showFareDifferenceMessage: res.invalid_seat_fare_hash
      //             ? res.invalid_seat_fare_hash.message
      //             : 'The fare of this service has changed. Do you want to proceed?',
      //           showFareDifferenceModal: true,
      //           showFareDifferenceBody: res.invalid_seat_fare_hash,
      //           paymentGatewayString: res.data.html_str,

      //           //--------------test data-----------------
      //           //   showFareDifferenceBody: {
      //           //     onward: {
      //           //       '35': {
      //           //         ui_fare: 25001.0,
      //           //         gds_fare: 5000.0,
      //           //       },
      //           //     },
      //           //     return: {
      //           //       '35': {
      //           //         ui_fare: 25001.0,
      //           //         gds_fare: 5000.0,
      //           //       },
      //           //     },
      //           //     status: 444,
      //           //     message: 'The fare of this service has changed. Do you want to proceed?',
      //           //   },
      //         });
      //       } else if (res && res.data && res.data.code == 'SEATS_UNAVAILABLE') {
      //         //SENDING CUSTOMER BACK TO COACH LAYO0UT BASED ON THE RETURN TRIP OR ONWARDF TRIP ONLY
      //         this.setState({
      //           // bookingError: res.message,
      //           showSuccessModel: true,
      //           successModelSuccess: false,
      //           successModelText:
      //             'El asiento que seleccionaste ya no está disponible. Por favor selecciona otro asiento.',
      //           showButton2: false,
      //           showButton1: true,
      //           onModalOkClick: () => {
      //             CommonService.passengerDetailsOnward = CommonService.copyObject(
      //               data.passengerDetailsOnward,
      //             );
      //             CommonService.passengerContactDetails = CommonService.copyObject(
      //               data.contactDetails,
      //             );
      //             if (data.returnPBDate) {
      //               // console.log('<<<<<<<<<<<<<<<<<<<<<<<<<<Inside if>>>>>>>>>>>>>>>>>>>>>>');
      //               // this.props.history.goBack(2);
      //               window.history.go(-2);
      //               CommonService.passengerDetailsReturn = CommonService.copyObject(
      //                 data.passengerDetailsReturn,
      //               );
      //             } else {
      //               // this.props.history.goBack();
      //               window.history.go(-1);
      //             }
      //             this.setState({
      //               showSuccessModel: false,
      //               successModelText: null,
      //               showButton1: false,
      //             });
      //           },
      //         });
      //       } else if (res.data.message) {
      //         this.setState({
      //           bookingError: res.data.message,
      //           // showSuccessModel: true,
      //           // successModelSuccess: false,
      //           // successModelText: res.message,
      //           // showButton2: false,
      //           // onModalOkClick: () => {
      //           //   this.setState({ showSuccessModel: false, successModelText: null })
      //           // }
      //         });
      //       } else if (res.data.result && res.data.result.pnr_number) {
      //         this.callGTMForDataPush(data, res.data.pnr_number);
      //         this.props.history.push(`/booking/success/${res.data.result.pnr_number}`);
      //       } else {
      //         this.setState({
      //           // bookingError: res.message,
      //           showSuccessModel: true,
      //           successModelSuccess: false,
      //           successModelText: 'The fare of this service has changed',
      //         });
      //       }
      //     });
      const details = data.passengerDetailsOnward[0];

      const bookingJSON = {
        booking: {
          origin_id: this.state.tariffData.origin.id,
          destination_id: this.state.tariffData.destination.id,
          no_of_passengers: this.state.tariffData.no_of_passengers,
          first_name: details.name,
          last_name: details.last_name,
          nationality: details.nationality.value,
          document: details.nationality.label,
          document_number: details.idCardNumber,
          discount_id:this.state.promoData ? this.state.promoData.discount_id:"",
          discount:this.state.promoData ?this.state.promoCouponAmount:"",
          email: data.contactDetails.email,
          phone_number: data.contactDetails.mobile,
          is_round_trip: this.state.isRoundTrip,
          pay_gay_type: this.state.selectedPaymentGateway,
          one_click_details: {},
          fe_success_url: `${window.location.origin}/terminal-booking/success`,
          fe_failure_url: `${window.location.origin}/terminal-booking/failure`,
        },
      };

      this.props.actions
        .apiCall({ url: ApiUrls.bookTicketTheme11(), data: bookingJSON, method: 'POST' })
        .then(res => {
          if (res && res.data && res.data.data && res.data.data.html_str) {
            localStorage.setItem('paymentGatewayOpened', true);
            document.write(res.data.data.html_str);
          }
        });
    } catch (e) {
      console.log(e);
    }
  };

  walletMoneyAdded = netFare => {
    // instant discount
    try {
      if (
        this.props.common.loginData &&
        this.props.common.loginData.balances &&
        this.state.wallet
      ) {
        let money = this.props.common.loginData.balances.clp.money;
        let virtualMoney = 0;
        if (this.state.virtual) {
          virtualMoney = this.virtualMoneyAmount();
        }
        let corpDiscount = +(this.state.corporateDiscountState &&
        this.state.corporateDiscountState.type == 1
          ? this.state.corporateDiscountState.discount_amount
          : 0);

        let instantDiscount = +(this.state.instantDiscount && this.state.instantDiscount.type == 1
          ? this.state.instantDiscount.discount_amount
          : 0);

        let cardDiscount = +(this.state.cardDiscountData &&
        this.state.cardDiscountData.card_applicable_discount
          ? this.state.cardDiscountData.card_applicable_discount
          : 0);

        let discount = 0;
        if (cardDiscount) {
          discount = cardDiscount;
        } else {
          discount = instantDiscount > corpDiscount ? instantDiscount : corpDiscount;
        }

        if (money) {
          if (
            +money >
            +netFare -
              +(this.state.promoCouponAmount ? this.state.promoCouponAmount : 0) -
              corpDiscount
          ) {
            return (
              +netFare -
              +(this.state.promoCouponAmount ? this.state.promoCouponAmount : 0) -
              virtualMoney -
              discount
            );
          }
          return +money;
        }
      }
      return 0;
    } catch (e) {
      console.log(e);
    }
  };

  virtualMoneyAmount = () => {
    try {
      if (
        this.props.home &&
        this.props.home.metaData &&
        this.props.home.metaData.allowed_virtual_limit &&
        this.props.common.loginData.balances.clp.credit
      ) {
        let fare = this.basicFare();
        // let cardDiscount = +(this.state.cardDiscountData &&
        //   this.state.cardDiscountData.card_applicable_discount
        //   ? this.state.cardDiscountData.card_applicable_discount
        //   : 0);

        let instantDiscount = +(this.state.instantDiscount && this.state.instantDiscount.type == 1
          ? this.state.instantDiscount.discount_amount
          : 0);

        console.log({ instantDiscount });

        fare = fare - instantDiscount;

        console.log({ fare });
        let money = +((this.props.home.metaData.allowed_virtual_limit / 100) * fare).toFixed(0);

        // return money > fare ? fare : money;
        if (money > this.props.common.loginData.balances.clp.credit) {
          return this.props.common.loginData.balances.clp.credit;
        } else if (money > fare) {
          return fare;
        } else {
          return money;
        }
      }
      return +((0 / 100) * this.props.common.loginData.balances.clp.credit).toFixed(0);
    } catch (e) {
      console.log(e);
    }
  };

  basicFare = () => {
    try {
      let fare =
       (this.props.pbServiceList && this.props.pbServiceList.bookingDetailsOnward
          ? this.props.pbServiceList.bookingDetailsOnward.netBookingAmount
          : 0) || (this.state.isRoundTrip?this.state.tariffData.round_trip_fare*this.state.tariffData.no_of_passengers:this.state.tariffData.total_fare)
      if (this.props.home.returnPBDate) {
        fare +=
          this.props.pbServiceList && this.props.pbServiceList.bookingDetailsReturn
            ? this.props.pbServiceList.bookingDetailsReturn.netBookingAmount
            : 0;
      }
      return fare;
    } catch (e) {
      console.log(e);
    }
  };

  originalBaseFare = () => {
    try {
      let fare =
        this.props.pbServiceList && this.props.pbServiceList.bookingDetailsOnward
          ? this.props.pbServiceList.bookingDetailsOnward.totalBookingAmount
          : 0;
      if (this.props.home.returnPBDate) {
        fare +=
          this.props.pbServiceList && this.props.pbServiceList.bookingDetailsReturn
            ? this.props.pbServiceList.bookingDetailsReturn.totalBookingAmount
            : 0;
      }

      return fare;
    } catch (e) {
      console.log(e);
    }
  };

  calculateNetFare = () => {
    try {
      let fare = this.basicFare();
      let virtualMoney = 0;
      if (this.state.virtual) {
        virtualMoney = this.virtualMoneyAmount();
      }
      if (this.state.wallet) {
        fare = fare - +this.walletMoneyAdded(fare) < 0 ? 0 : fare - +this.walletMoneyAdded(fare);
      }
      let netFare = fare - +(this.state.promoCouponAmount ? this.state.promoCouponAmount : 0);
      let corpDiscount = +(this.state.corporateDiscountState &&
      this.state.corporateDiscountState.type == 1
        ? this.state.corporateDiscountState.discount_amount
        : 0);

      let instantDiscount = +(this.state.instantDiscount && this.state.instantDiscount.type == 1
        ? this.state.instantDiscount.discount_amount
        : 0);

      let cardDiscount = +(this.state.cardDiscountData &&
      this.state.cardDiscountData.card_applicable_discount
        ? this.state.cardDiscountData.card_applicable_discount
        : 0);

      let discount = 0;
      if (cardDiscount) {
        discount = cardDiscount;
      } else {
        discount = instantDiscount > corpDiscount ? instantDiscount : corpDiscount;
      }

      let motDiscount = this.props.home.is_mot && this.state.motData;

      return netFare - virtualMoney - discount > 0 && !motDiscount
        ? netFare - virtualMoney - discount
        : motDiscount
        ? 0
        : 0;

      // return netFare - virtualMoney - discount > 0 ? netFare - virtualMoney - discount : 0;
    } catch (e) {
      console.log(e);
    }
  };

  calculateNetFareUSD = () => {
    if (
      this.props.home &&
      this.props.home.metaData &&
      this.props.home.metaData.currency_conversions
    ) {
      return (
        this.calculateNetFare() * this.props.home.metaData.currency_conversions.clp_to_usd
      ).toFixed('2');
    }
  };

  renderContactInputTable = () => {
    const { t } = this.props;
    return (
      <table className="passenger-input-personal-details">
        <tbody>
          <tr className="passenger-input-heading bold-text font10">
            <th className="emailinput">{t('PASSENGER_DETAILS.EMAIL_ID')}</th>
            <th className="email-input">{t('PASSENGER_DETAILS.EMAIL_CONFIRMATION')}</th>
            <th className="phone-input">{t('PASSENGER_DETAILS.PHONE_NUMBER')}</th>
          </tr>
          <tr className="passenger-input font10">
            <td className="email-input">
              <KuposInput
                className="kupos-border"
                type="email"
                value={
                  this.props.pbPaymentDetails.contactDetails
                    ? this.props.pbPaymentDetails.contactDetails.email
                    : ''
                }
                onChange={text => this.onInputChange(text, 'email')}
                onBlur={text => this.onInputBlurContact(text, 'email')}
                error={this.state.emailError ? true : false}
                errorMessage={this.state.emailError ? t(this.state.emailError.message) : ''}
              />
            </td>
            <td className="email-input">
              <KuposInput
                className="kupos-border confirm-email"
                type="email"
                value={
                  this.props.pbPaymentDetails.contactDetails
                    ? this.props.pbPaymentDetails.contactDetails.confirmEmail
                    : ''
                }
                onChange={text => this.onInputChange(text, 'confirmEmail')}
                onBlur={text => this.onInputBlurContact(text, 'confirmEmail')}
                error={this.state.confirmEmailError ? true : false}
                errorMessage={
                  this.state.confirmEmailError ? t(this.state.confirmEmailError.message) : ''
                }
              />
            </td>
            <td className="phone-input">
              <KuposInput
                placeholder="9XXXXXXXX"
                className="kupos-border"
                type="tel"
                value={
                  this.props.pbPaymentDetails.contactDetails
                    ? this.props.pbPaymentDetails.contactDetails.mobile
                    : ''
                }
                onChange={text => this.onInputChange(text, 'mobile')}
                onBlur={text => this.onInputBlurContact(text, 'mobile')}
                error={this.state.mobileError ? true : false}
                errorMessage={this.state.mobileError ? t(this.state.mobileError.message) : ''}
              />
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  onPaymentTypeSelect = paymentItem => {
    paymentItem
      ? this.setState({
          selectedPaymentGateway:
            this.state.selectedPaymentGateway == paymentItem.code ? null : paymentItem.code,
          cardChecked: false,
          payment_mode: paymentItem.payment_mode,
        })
      : this.setState({
          selectedPaymentGateway: 34,
          cardChecked: true,
          payment_mode: 34,
        });
  };

  checkWallet = selected => {
    if (CommonService.isLoggedIn(this.props.common.loginData) && selected == '39:3') {
      this.setState({ wallet: !this.state.wallet });
    } else {
      this.setState({ wallet: false });
    }
  };
  checkVirtual = () => {
    if (CommonService.isLoggedIn(this.props.common.loginData)) {
      this.setState({ virtual: !this.state.virtual });
    } else {
    }
  };

  applyPromoCode = () => {
  
    console.log("@@@@@@@@")
    console.log(this.props.pbServiceList,"!!!!!!!!!!!!!!!!")
    try {
      // Check if promoCode exists in state
      if (!this.state.promoCode) {
        this.setState({
          promoCodeError: {
            message: 'VALIDATIONS.VALID_PROMOTION',
          },
        });
        return;
      }
  
      console.log(this.tariffData, "@@@@@@@@");
      console.log(this.props.data, "##########");
  
      // Keyboard.dismiss(); // Assuming you have a Keyboard import
  
      // Repeat the promoCode check
      // if (!this.state.promoCode) {
      //   this.setState({
      //     promoCodeError: {
      //       message: "Introduce el código de promoción",
      //     },
      //   });
      //   return;
      // }
  
      // Check if tariffData and state are properly defined and extract values
      let fare = this.basicFare()
  
      let booking_type = this.state.isRoundTrip ? "roundtrip" : "oneway";
  
      // Check if props and data are defined
      const dateStr = (this.props.home.onwardPBDate) || '';
  
      // if (!dateStr) {
      //   console.log("Invalid date string");
      //   return;
      // }
  
      // Split the string into day, month, and year
      const dateParts = dateStr.split("-");
      const [day, month, year] = dateParts.length === 3 ? dateParts : ['', '', ''];
  
      // if (!day || !month || !year) {
      //   console.log("Date format is incorrect");
      //   return;
      // }
  console.log("*****************")
      // Rearrange the parts into the desired format
      const formattedDate = `${year}-${month}-${day}`;
  
      // Assuming getApiCall is a method provided by props

      this.props.actions.apiCall({
        url:AppData.BASE_URL + `api/airport_discounts?travel_date=${formattedDate}&return_travel_date=${this.state.isRoundTrip ? formattedDate : ""}&net_amount=${fare}&booking_type=${booking_type}&code=${this.state.promoCode}&platform=centropuerto`,
        method:'GET',
        type:'home',
        callback: (res) => {
          console.log(res,"^^^^^^^^^^^^")
          if (res.data.http_code !=200) {
            this.setState({
              promoCodeError: {
                message: res.data.message
              },
            });
            console.log("Something went wrong");
          } else {
            this.setState({
              promoData: res.data.data,
              promoCodeApplied: true,
              promoCouponAmount: res.data.data.applicable_discount,
              showSuccessModel: true,
              successModelSuccess: true,
              successModelText: this.props.t('PASSENGER_DETAILS.PROMO_CODE_SUCCESS'),
            });
            console.log(res.data.data, "LOG____DATA");
          }
          console.log(this.state.promoData,")))))))))))))))))")
          console.log(this.tariffData);
          console.log("PROMO COUPON amount", this.state.promoCouponAmount);
          console.log(res, "%%%%%%%%%%%%%%");
        }
      });
      console.log("Promo code:", this.state.promoCode);
    } catch (err) {
      console.log(err);
    }
  };
  
  onPromoApply = result => {
    if (result) {
      if (result.status == 200) {
        this.setState({
          promoCodeApplied: true,
          promoCouponAmount: result.discount_amount,
          promoType: result.type,
          discountText: result.discount_text,
          showSuccessModel: true,
          successModelSuccess: true,
          successModelText: this.props.t('PASSENGER_DETAILS.PROMO_CODE_SUCCESS'),
        });
      } else {
        this.setState({
          promoCodeError: {
            message: result.message,
          },
          // showSuccessModel:true,
          // successModelSuccess:false,
          // showButton1:true,
          // showButton2:true,
          // successModelText:this.props.t("PASSENGER_DETAILS.PROMO_CODE_DOES_NOT_EXIST")
        });
      }
    }
  };

  promoCodeBlur = text => {
    if (!text) {
      this.setState({
        promoCodeError: {
          message: 'VALIDATIONS.VALID_PROMOTION',
        },
      });
    }
  };

  promoCodeChange = text => {
    this.setState({
      promoCodeError: null,
      promoCode: text,
    });
  };

  promoCheckboxChange = () => {
    this.setState({
      promoCodeChecked: !this.state.promoCodeChecked,
      promoCodeError: null,
      promoCode: '',
      promoCouponAmount: null,
      promoType: null,
      promoCodeApplied: false,
      discountText: null,
    });
  };

  renderNotLoggedInBlock = () => {
    return (
      <div className="kupos-card dont-have-account-block flex-row">
        <div>
          <div className="heading bold font13">{this.props.t('PASSENGER_DETAILS.NO_ACCOUNT')}</div>
          <div className="font10">
            {this.props.t('PASSENGER_DETAILS.CREATE_YOURS_AND_GET_BENIFIT')}
          </div>
        </div>
        <div>
          <button className="kupos-button font12" onClick={() => this.openLoginModal()}>
            <span>{this.props.t('PASSENGER_DETAILS.CREATE_ACCOUNT')}</span>
          </button>
        </div>
      </div>
    );
  };

  openLoginModal = () => {
    this.props.actions.openCloseLoginModal(true);
  };
  cardChoosen = (val, key) => {
    this.setState({
      selectedCard: val,
      cardChecked: true,
      // selectedPaymentGateway: null,
    });
  };

  renderPaymentMain = operator => {
    return (
      <div className="pb-service-list-payment-details-page content-container flex-row passenger-and-payment-details-container">
        <div className="passenger-input-container">
          {/* {!CommonService.isLoggedIn() ? this.renderNotLoggedInBlock() : null} */}
          <div className="kupos-card passenger-input-details">
            <div className="flex-row passenger-details-title-row">
              <div className="font13 bold">
                {this.props.t('PASSENGER_DETAILS.PASSENGER_DETAIL.NORMAL')}
                {this.props.t('PASSENGER_DETAILS.PASSENGER_DETAIL.BOLD')}
              </div>

              <div className=" bold-text countdown-counter font13" style={{ position: 'relative' }}>
                {this.state.timeInfoHover ? (
                  <span
                    className="info-popup font10 normal-text"
                    style={
                      Number(this.state.countdown.split(':')[0]) < 3
                        ? {
                            top: -16,
                            right: 110,
                            width: '400%',
                            color: '#464647',
                            textAlign: 'center',
                          }
                        : {
                            top: -4,
                            right: 110,
                            width: '400%',
                            color: '#464647',
                            textAlign: 'center',
                          }
                    }
                  >
                    {Number(this.state.countdown.split(':')[0]) < 3
                      ? this.props.t('PROFILE.TIME_LEFT_LESS_THREE')
                      : this.props.t('PROFILE.TIME_LEFT_TO_PURCHASE')}
                  </span>
                ) : null}
                <img
                  onMouseEnter={() => this.setState({ timeInfoHover: true })}
                  onMouseLeave={() => this.setState({ timeInfoHover: false })}
                  src="/assets/centropuerto/buy/Timer.svg"
                  className="clock-over"
                  alt="clock-over"
                />

                <span
                  style={{
                    color:
                      operator && operator.color_codes && operator.color_codes.button_color
                        ? operator.color_codes.button_color
                        : '',
                  }}
                >
                  {this.state.countdown}
                </span>
              </div>
            </div>
            {/* <div className="passenger-inputs-block">
              <span className="bold journey-type-title font10">
                {this.props.t('PASSENGER_DETAILS.GOING')}
              </span>
            </div> */}

            {this.props.pbServiceList &&
            this.props.pbServiceList.bookingDetailsOnward &&
            this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook ? (
              <BookingInput
                selectedSeatsToBook={
                  this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook
                }
                idCardTypes={this.idCardTypes}
                countries={this.countries}
                passengerDetails={this.props.pbPaymentDetails.passengerDetailsOnward}
                onNameChange={(text, seat) => this.onNameChange(text, seat)}
                onLastNameChange={(text, seat) => this.onLastNameChange(text, seat)}
                onCountryChange={(val, seat) => this.onCountryChange(val, seat)}
                onIdCardChange={(label, seat) => this.onIdCardChange(label, seat)}
                onIdCardNumberChange={(text, seat) => this.onIdCardNumberChange(text, seat)}
                onInputBlur={(text, seat, inp) => this.onInputBlur(text, seat, inp)}
                nameError={this.state.nameError}
                last_nameError={this.state.last_nameError}
                cardNumberError={this.state.cardNumberError}
                dobError={this.state.dobError}
                originCountryError={this.state.originCountryError}
                originAddressError={this.state.originAddressError}
                genderError={this.state.genderError}
                seatsTitle="DATOS DEL PASAJERO (IDA)"
                t={this.props.t}
                operator={operator}
                home={this.props.home}
                onUserDOBChange={(text, seat) => this.onUserDOBChange(text, seat)}
                onOriginCountryChange={(val, seat) => this.onOriginCountryChange(val, seat)}
                onOriginAddressChange={(val, seat) => this.onOriginAddressChange(val, seat)}
                onGenderChange={(val, seat) => this.onGenderChange(val, seat)}
                type={'onward'}
              />
            ) : null}

            {this.renderContactInputTable()}
          </div>

          <div className="mt-40" />

          <PaymentOptions
            paymentGatewayList={this.paymentGatewayList}
            selected={this.state.selectedPaymentGateway}
            onPaymentSelect={this.onPaymentTypeSelect}
            walletChecked={this.state.wallet}   
            virtualChecked={this.state.virtual}
            walletMoney={
              this.props.common.loginData && this.props.common.loginData.balances
                ? this.props.common.loginData.balances.clp.money
                : ''
            }
            virtualMoney={
              this.props.common.loginData && this.props.common.loginData.balances
                ? this.props.common.loginData.balances.clp.credit
                : ''
            }
            isLoggedIn={
              this.props.common.loginData && this.props.common.loginData.auth_token ? true : false
            }
            checkWallet={this.checkWallet}
            checkVirtual={this.checkVirtual}
            onPay={this.onSubmit}
            bookTicketPending={this.state.isLoading}
            bookingError={this.state.bookingError}
            onBookingErrorClick={() => this.setState({ bookingError: null })}
            onPromoCheckboxChange={this.promoCheckboxChange}
            promoCodeChecked={this.state.promoCodeChecked}
            onPromoCodeChange={this.promoCodeChange}
            onPromoCodeBlur={this.promoCodeBlur}
            applyPromoCodePending={this.props.pbPaymentDetails.applyPromoCodePending}
            onApplyPromoCode={this.applyPromoCode}
            promoCodeError={
              this.state.promoCodeError ? this.props.t(this.state.promoCodeError.message) : null
            }
            t={this.props.t}
            history={this.props.history}
            tncChecked={this.state.tncChecked ? true : false}
            onTncChange={() => this.setState({ tncChecked: !this.state.tncChecked })}
            totalAmount={this.calculateNetFare()}
            showKuposPay={true}
            showPaypal={true}
            showPromocode={true}
            showBancoEstado={true}
            corporateDiscountState={this.state.corporateDiscountState}
            instantDiscount={this.state.instantDiscount}
            operator={operator}
            myCards={this.state.myCards ? this.state.myCards : null}
            cardTypes={this.state.oneClickCardTypes ? this.state.oneClickCardTypes : null}
            cardChoosen={this.cardChoosen}
            cardChecked={this.state.cardChecked}
            isOneClickEnabled={this.state.isOneClickEnabled}
            setMotData={this.setMotData}
            is_mot={this.props.home.is_mot}
            actions={this.props.actions}
            selectedServiceRouteOnward={this.props.pbServiceList.selectedServiceOnward.route}
            tncContainerStyle={{ alignItems: 'center', justifyContent: 'flex-start' }}
          />
        </div>

        <PaymentRightSideBar
          totalSeats={
            this.props.pbServiceList &&
            this.props.pbServiceList.bookingDetailsOnward &&
            this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook &&
            this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook.length
          }
          tariffData={this.state.tariffData}
          isRoundTrip={this.state.isRoundTrip}
          amountPerSeat={this.state.tariffData.fare}
          basicFare={this.basicFare}
          calculateNetFare={this.calculateNetFare}
          calculateNetFareUSD={this.calculateNetFareUSD}
          promoCode={this.state.promoCode}
          onPromoRemove={this.promoCheckboxChange}
          promoCouponAmount={this.state.promoCouponAmount}
          showUsd={this.state.selectedPaymentGateway == 23 ? true : false}
          corporateDiscountState={this.state.corporateDiscountState}
          instantDiscount={this.state.instantDiscount}
          t={this.props.t}
          operator={operator}
          is_mot={this.props.home.is_mot}
          motData={this.state.motData}
          metaData={this.props.home.metaData}
        />
      </div>
    );
  };

  renderBookingConfirmation = operator => {
    if (this.state.status == 'success') {
      return (
        <BookingSuccess
          pnrNumber={this.state.pnrNumber}
          loading={this.props.common.loadTicketDetailsPending}
          ticketDetails={this.props.common.ticketDetails && this.props.common.ticketDetails.body}
          history={this.props.history}
          success={true}
          t={this.props.t}
          appType={localStorage.getItem('appType')}
          operator={operator}
        />
      );
    } else if (this.state.status == 'failure') {
      return <BookingSuccess success={false} operator={operator} />;
    }
  };

  render() {
    const { t } = this.props;
    const operator = CommonService.getLocal('op') || this.props.home.operator;
    console.log(' this.props.pbServiceList', this.props.pbServiceList, this.props.pbPaymentDetails);

    return (
      <div
        className="pb-payment-details-default-page"
        style={{ marginTop: operator && operator.theme_type == 2 ? '15vh' : '25vh' }}
      >
        <KuposHelmet />
        <div className="content-container"></div>
        {!this.state.status
          ? this.renderPaymentMain(operator)
          : this.renderBookingConfirmation(operator)}

        <KuposErrorSuccessModal
          showModal={this.state.showSuccessModel}
          success={this.state.successModelSuccess}
          bodyText={this.state.successModelText}
          onButtonClick={
            this.state.onModalOkClick
              ? this.state.onModalOkClick
              : () => this.setState({ showSuccessModel: false, successModelText: null })
          }
          showButton1={this.state.showButton1}
          buttonText1={'OK, VOLVER'}
          onButtonClick1={
            this.state.onModalOkClick
              ? this.state.onModalOkClick
              : () =>
                  this.setState({
                    showSuccessModel: false,
                    successModelText: null,
                    showButton1: false,
                    showButton2: false,
                  })
          }
          showButton2={this.state.showButton2}
          buttonText2={'CONTÁCTANOS'}
          onButtonClick2={() => this.props.history.push('/pages/contact')}
          operator={this.props.home.operator}
        />
        <KuposModalWithButtons
          size="md"
          showButton1={true}
          showModal={this.state.showErrorsModal}
          onHide={() => this.setState({ showErrorsModal: false })}
          operator={this.props.home.operator}
        >
          {<span className="font11">{this.state.error}</span>}
        </KuposModalWithButtons>
        <KuposModalWithButtons
          size="md"
          showButton1={true}
          buttonText1={this.props.t('PROFILE.BACK_TO_RESULTS')}
          showModal={this.state.showTimeUpModal}
          onHide={() => {
            sessionStorage.removeItem('paymentCounter');
            // if (this.iframe_operator_id) {
            //   window.open(this.props.home.operatorSites.domain_url, '_parent');
            // } else {
            //   this.props.history.replace('', null);
            // }
            this.props.history.push('/');
          }}
          icon="/static/images/icons/timeup.png"
          title={this.props.t('HOME.WE_ARE_SORRY')}
          bodyText={this.props.t('PROFILE.PAYMENT_EXPIRY')}
          operator={this.props.home.operator}
        />
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    pbServiceList: state.pbServiceList,
    home: state.home,
    pbPaymentDetails: state.pbPaymentDetails,
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...actions, ...homeActions, ...serviceActions, ...commonActions, ...paymentActions },
      dispatch,
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(DefaultPage));



// WEBPACK FOOTER //
// ./src/features/terminal-booking/DefaultPage.js